var map = {
	"./TOY_DHD_Hauptgewinn-Yaris-1000.jpg": 701,
	"./TOY_DHD_Hauptgewinn-Yaris-1600.jpg": 702,
	"./UCI-logo.jpg": 703,
	"./UCI-logo@2x.jpg": 704,
	"./UCI-logo@3x.jpg": 705,
	"./accountSection__profileImage--dark.png": 706,
	"./accountSection__profileImage.png": 707,
	"./accountSection__settings--dark.png": 708,
	"./accountSection__settings.png": 709,
	"./accountSection__settingsClose--dark.png": 710,
	"./accountSection__settingsClose.png": 711,
	"./announceGroup__bg.jpg": 712,
	"./announceGroup__icon.png": 713,
	"./announceGroup__textBg.png": 714,
	"./appIcon.png": 715,
	"./appLogo.jpg": 716,
	"./appLogo.png": 717,
	"./appTitle.png": 718,
	"./app_buttons/button__appStore--fr.svg": 719,
	"./app_buttons/button__appStore.svg": 720,
	"./app_buttons/button__googlePlay--fr.svg": 721,
	"./app_buttons/button__googlePlay.svg": 722,
	"./avatarFallback.png": 723,
	"./bet1x2__checkedOption.png": 724,
	"./betSponsor.png": 725,
	"./betSponsor__externalLink.png": 726,
	"./bet__bg--dhi.jpg": 727,
	"./bet__bg--xcc.jpg": 728,
	"./bet__bg--xco.jpg": 729,
	"./bet__correctMarker@2x.png": 730,
	"./bet__wrongMarker@2x.png": 731,
	"./bonusForSharing__bg.jpg": 732,
	"./bottomBanner.png": 733,
	"./championship__iconChangeTeam.png": 734,
	"./championship__iconCorrect.png": 735,
	"./championship__iconDown.png": 736,
	"./championship__iconPickTeam--plain.png": 737,
	"./championship__iconPickTeam.png": 738,
	"./championship__iconUp.png": 739,
	"./championship__iconWrong.png": 740,
	"./client_footer__background--desktopDown.png": 741,
	"./client_footer__background--desktopLargeUp.png": 742,
	"./client_footer__background--onlyPhone.png": 743,
	"./communities/samsung_dark.png": 744,
	"./communities/samsung_light.png": 745,
	"./countdown__background.jpg": 746,
	"./dailySpecialMarker@3x.png": 747,
	"./details__prizeBox__event__first.png": 748,
	"./details__prizeBox__event__second.png": 749,
	"./details__prizeBox__event__third.png": 750,
	"./details__prizeBox__season__first.png": 751,
	"./details__prizeBox__season__second.png": 752,
	"./details__prizeBox__season__third.png": 753,
	"./details__prizeBox__stretch__first.png": 754,
	"./details__prizeBox__stretch__second.png": 755,
	"./details__prizeBox__stretch__third.png": 756,
	"./dragDrop__infoIcon@3x.png": 757,
	"./drivers/DEFAULT.jpg": 758,
	"./drivers/DEFAULT.png": 759,
	"./drivers/small/DEFAULT.jpg": 760,
	"./drivers/small/DEFAULT.png": 761,
	"./emblems/8582_wappen_dozwil.png": 762,
	"./emblems/Aarberg-coat_of_arms.svg": 763,
	"./emblems/Aarwangen-coat_of_arms.svg": 764,
	"./emblems/Acquarossa-coat_of_arms.svg": 765,
	"./emblems/Adelboden-coat_of_arms.svg": 766,
	"./emblems/Adligenswil_LU.png": 767,
	"./emblems/Adliswil-blazon.svg": 768,
	"./emblems/Aedermannsdorf-blason.png": 769,
	"./emblems/Aefligen-coat_of_arms.svg": 770,
	"./emblems/Aegerten-coat_of_arms.svg": 771,
	"./emblems/Aesch-blazon.svg": 772,
	"./emblems/Aesch_LU.png": 773,
	"./emblems/Aeschi-blason.png": 774,
	"./emblems/Aeschi_bei_Spiez-coat_of_arms.svg": 775,
	"./emblems/Aeugst_am_Albis-blazon.svg": 776,
	"./emblems/Affeltra.png": 777,
	"./emblems/Affoltern_am_Albis-blazon.svg": 778,
	"./emblems/Affoltern_im_Emmental-coat_of_arms.svg": 779,
	"./emblems/Agarn.png": 780,
	"./emblems/Agno-coat_of_arms.svg": 781,
	"./emblems/AireLaVille-coat_of_arms.svg": 782,
	"./emblems/Airolo-coat_of_arms.svg": 783,
	"./emblems/Alberswil_LU.png": 784,
	"./emblems/Albinen-coat_of_arms.svg": 785,
	"./emblems/Albula-Alvra_Wappen.svg": 786,
	"./emblems/Alchenstorf-coat_of_arms.svg": 787,
	"./emblems/Alle-coat_of_arms.svg": 788,
	"./emblems/Allmendingen-coat_of_arms.svg": 789,
	"./emblems/Alpnach-coat_of_arms.svg": 790,
	"./emblems/Altbueron_LU.png": 791,
	"./emblems/Altikon-blazon.svg": 792,
	"./emblems/Altishofen_LU.png": 793,
	"./emblems/Altnau_CoA.svg": 794,
	"./emblems/AltoMalcantone-coat_of_arms.svg": 795,
	"./emblems/Amden_SG_flago.png": 796,
	"./emblems/Amlikon_Bissegg_Blazono.png": 797,
	"./emblems/Amriswil_CoA.svg": 798,
	"./emblems/Amsoldingen-coat_of_arms.svg": 799,
	"./emblems/Andeer_wappen.svg": 800,
	"./emblems/Andermatt-coat_of_arms.svg": 801,
	"./emblems/Andwil-SG-flago.png": 802,
	"./emblems/Anieres-coat_of_arms.svg": 803,
	"./emblems/Anniviers.png": 804,
	"./emblems/Appenzell-Wappen.png": 805,
	"./emblems/Aranno-coat_of_arms.svg": 806,
	"./emblems/ArbedoCastione-coat_of_arms.svg": 807,
	"./emblems/Arch-coat_of_arms.svg": 808,
	"./emblems/Ardon-blazono.png": 809,
	"./emblems/Armoiries_Enfers.png": 810,
	"./emblems/Armoiries_bercher.svg": 811,
	"./emblems/Arnex-sur-Nyon-coat_of_arms.svg": 812,
	"./emblems/Arnex-sur-Orbe-coat_of_arms.svg": 813,
	"./emblems/Arni_bei_Biglen-coat_of_arms.svg": 814,
	"./emblems/Arogno-coat_of_arms.svg": 815,
	"./emblems/Arzier-coat_of_arms.svg": 816,
	"./emblems/Ascona-coat_of_arms.svg": 817,
	"./emblems/Attalens-coat_of_arms.svg": 818,
	"./emblems/Attinghausen-coat_of_arms.svg": 819,
	"./emblems/Attiswil-coat_of_arms.svg": 820,
	"./emblems/Aubonne-coat_of_arms.svg": 821,
	"./emblems/Ausserberg.png": 822,
	"./emblems/Auswil-coat_of_arms.svg": 823,
	"./emblems/Autigny-coat_of_arms.svg": 824,
	"./emblems/Avenches-coat_of_arms.png": 825,
	"./emblems/Avers_wappen.svg": 826,
	"./emblems/Avry-coat_of_arms.svg": 827,
	"./emblems/Avully-coat_of_arms.svg": 828,
	"./emblems/Avusy-coat_of_arms.svg": 829,
	"./emblems/Ayent.png": 830,
	"./emblems/Baar-coat_of_arms.svg": 831,
	"./emblems/Bachenbuelach-blazon.svg": 832,
	"./emblems/Bachs-coat_of_arms.svg": 833,
	"./emblems/Bad_Ragaz-Blazono.png": 834,
	"./emblems/Baeretswil-blazon.svg": 835,
	"./emblems/Baeriswil-coat_of_arms.svg": 836,
	"./emblems/Baerschwil-blason.png": 837,
	"./emblems/Baetterkinden-coat_of_arms.svg": 838,
	"./emblems/Baettwil-blason.png": 839,
	"./emblems/Balerna-coat_of_arms.svg": 840,
	"./emblems/Balgach_coats_of_arms.png": 841,
	"./emblems/Ballaigues-coat_of_arms.svg": 842,
	"./emblems/Ballens-coat_of_arms.svg": 843,
	"./emblems/Ballwil_LU.png": 844,
	"./emblems/Balm_bei_Guensberg-blason.png": 845,
	"./emblems/Bannwil-coat_of_arms.svg": 846,
	"./emblems/Bardonnex-coat_of_arms.svg": 847,
	"./emblems/Bargen-coat_of_arms.svg": 848,
	"./emblems/Bas-Intyamon-coat_of_arms.svg": 849,
	"./emblems/Basadingen-Schlattingen-Blazono.png": 850,
	"./emblems/Bassersdorf-blazon.svg": 851,
	"./emblems/Bassins-coat_of_arms.svg": 852,
	"./emblems/Baulmes-coat_of_arms.svg": 853,
	"./emblems/Bauma-blazon.svg": 854,
	"./emblems/Bavois-coat_of_arms.svg": 855,
	"./emblems/Beatenberg-coat_of_arms.svg": 856,
	"./emblems/Beckenried-coat_of_arms.svg": 857,
	"./emblems/Bedano-coat_of_arms.svg": 858,
	"./emblems/Bedretto-coat_of_arms.svg": 859,
	"./emblems/Begnins-coat_of_arms.svg": 860,
	"./emblems/Beinwil_SO-blason.png": 861,
	"./emblems/Belfaux-coat_of_arms.svg": 862,
	"./emblems/Bellach-blason.png": 863,
	"./emblems/Bellevue-coat_of_arms.svg": 864,
	"./emblems/Bellmund-coat_of_arms.svg": 865,
	"./emblems/Bellwald.png": 866,
	"./emblems/Belmont-sur-Lausanne-coat_of_arms.svg": 867,
	"./emblems/Belmont-sur-Yverdon-coat_of_arms.svg": 868,
	"./emblems/Belp-coat_of_arms.svg": 869,
	"./emblems/Belprahon-coat_of_arms.svg": 870,
	"./emblems/Benken-blazon.svg": 871,
	"./emblems/Benken_SG_blazono.png": 872,
	"./emblems/Bennwil-blason.png": 873,
	"./emblems/Berg(Turgovio)-Blazono.png": 874,
	"./emblems/Berg-SG-blazono.png": 875,
	"./emblems/Berg_am_irchel-blazon.svg": 876,
	"./emblems/Berguen_(Kreis)_wappen.svg": 877,
	"./emblems/Berken-coat_of_arms.svg": 878,
	"./emblems/Berlingen_Wappen_2.svg": 879,
	"./emblems/Bernex-coat_of_arms.svg": 880,
	"./emblems/Berolle-coat_of_arms.svg": 881,
	"./emblems/Beromuenster_LU.png": 882,
	"./emblems/Besencens-Wappen.png": 883,
	"./emblems/Betten-coat_of_arms.svg": 884,
	"./emblems/Bettenhausen-coat_of_arms.svg": 885,
	"./emblems/BettingenWappen.gif": 4050,
	"./emblems/Bettlach-blason.png": 886,
	"./emblems/Bettwiesen-Blazono.png": 887,
	"./emblems/Bever_wappen.svg": 888,
	"./emblems/Biasca-coat_of_arms.svg": 889,
	"./emblems/Biberist-blason.png": 890,
	"./emblems/Bichelsee-Balterswil-Blazono.png": 891,
	"./emblems/Biel-coat_of_arms.svg": 892,
	"./emblems/Biere-coat_of_arms.svg": 893,
	"./emblems/Biezwil-blason.png": 894,
	"./emblems/Biglen-coat_of_arms.svg": 895,
	"./emblems/Billens-coat_of_arms.svg": 896,
	"./emblems/Binn-coat_of_arms.svg": 897,
	"./emblems/Bioggio-coat_of_arms.svg": 898,
	"./emblems/Bioley-Magnoux-coat_of_arms.svg": 899,
	"./emblems/Birmensdorf-blazon.svg": 900,
	"./emblems/Birwinken-Blazono.png": 901,
	"./emblems/Bischofszell-Blazono.png": 902,
	"./emblems/Bissone-coat_of_arms.svg": 903,
	"./emblems/Bister.png": 904,
	"./emblems/Bitsch.png": 905,
	"./emblems/Blason_Romainmotier-Envy.svg": 906,
	"./emblems/Blason_Saillon.svg": 907,
	"./emblems/Blason_Valbroye.png": 908,
	"./emblems/Blason_commune_CH_Assens_(Vaud).svg": 909,
	"./emblems/Blason_commune_CH_Bettens_(Vaud).svg": 910,
	"./emblems/Blason_commune_CH_Bottens_(Vaud).svg": 911,
	"./emblems/Blason_commune_CH_Boulens_(Vaud).svg": 912,
	"./emblems/Blason_commune_CH_Corbeyrier_(Vaud).svg": 913,
	"./emblems/Blason_commune_CH_Corcelles-pres-Payerne_(Vaud).svg": 914,
	"./emblems/Blason_commune_CH_Cudrefin_(Vaud).svg": 915,
	"./emblems/Blason_commune_CH_Etagnieres_(Vaud).svg": 916,
	"./emblems/Blason_commune_CH_Gryon_(Vaud).svg": 917,
	"./emblems/Blason_commune_CH_Henniez_(Vaud).svg": 918,
	"./emblems/Blason_commune_CH_Lavey-Morcles_(Vaud).svg": 919,
	"./emblems/Blason_commune_CH_Leysin_(Vaud).svg": 920,
	"./emblems/Blason_commune_CH_Montanaire_(Vaud).svg": 921,
	"./emblems/Blason_commune_CH_Noville_(Vaud).svg": 922,
	"./emblems/Blason_commune_CH_Ormont-Dessous_(Vaud).svg": 923,
	"./emblems/Blason_commune_CH_Rennaz_(Vaud).svg": 924,
	"./emblems/Blason_commune_CH_Rossenges_(Vaud).svg": 925,
	"./emblems/Blason_commune_CH_Treytorrens_(Vaud).svg": 926,
	"./emblems/Blason_commune_CH_Vully-les-Lacs_(Vaud).svg": 927,
	"./emblems/Blason_commune_CH_Yvorne_(Vaud).svg": 928,
	"./emblems/Blason_de_Cheyres-Chables.svg": 929,
	"./emblems/Blason_de_Sierre_Valais.svg": 930,
	"./emblems/Blason_mont-noble.svg": 931,
	"./emblems/Blason_saxon_suisse.svg": 932,
	"./emblems/Blason_suisse_commune_Chavannes-sur-Moudon.svg": 933,
	"./emblems/Blason_ville_CH_Bex_(Vaud).svg": 934,
	"./emblems/Blason_ville_ch_Mex_(Vaud).svg": 935,
	"./emblems/Blason_ville_ch_Ormont-Dessus_(Vaud).svg": 936,
	"./emblems/Blason_ville_suisse_Cornaux_(Neuchatel).svg": 937,
	"./emblems/Blasonvalderuz.png": 938,
	"./emblems/Bleienbach-coat_of_arms.svg": 939,
	"./emblems/Blenio_(Comune)-coat_of_arms.png": 940,
	"./emblems/Blumenstein-coat_of_arms.svg": 941,
	"./emblems/Boecourt.png": 942,
	"./emblems/Boenigen-coat_of_arms.svg": 943,
	"./emblems/Boesingen-coat_of_arms.svg": 944,
	"./emblems/Bofflens-coat_of_arms.svg": 945,
	"./emblems/Bogis-Bossey-coat_of_arms.svg": 946,
	"./emblems/Bois-ddAmont-blazon.svg": 947,
	"./emblems/Bolken-blason.png": 948,
	"./emblems/Bolligen-coat_of_arms.svg": 949,
	"./emblems/Boltigen-coat_of_arms.svg": 950,
	"./emblems/Bonaduz_wappen.svg": 951,
	"./emblems/Boncourt.png": 952,
	"./emblems/Boningen-blason.png": 953,
	"./emblems/Bonstetten-blazon.svg": 954,
	"./emblems/Bonvillars-coat_of_arms.svg": 955,
	"./emblems/Boppelsen-blazon.svg": 956,
	"./emblems/Borex-coat_of_arms.svg": 957,
	"./emblems/BoscoGurin-coat_of_arms.svg": 958,
	"./emblems/Bossonens-coat_of_arms.svg": 959,
	"./emblems/Bottighofen.png": 960,
	"./emblems/Boudry-coat_of_arms.svg": 961,
	"./emblems/Bougy-Villars-coat_of_arms.svg": 962,
	"./emblems/Bourg-Saint-Pierre-blazono.png": 963,
	"./emblems/Bournens-coat_of_arms.svg": 964,
	"./emblems/Bourrignon-Blazono.png": 965,
	"./emblems/Boussens-coat_of_arms.svg": 966,
	"./emblems/Bovernier-blazono.png": 967,
	"./emblems/Bowil-coat_of_arms.svg": 968,
	"./emblems/Braunau(Turgovio)-Blazono.png": 969,
	"./emblems/Bregaglia_(Kreis)_wappen.svg": 970,
	"./emblems/Breggia_CoA.png": 971,
	"./emblems/Breil_Brigels_wappen.svg": 972,
	"./emblems/Breitenbach-blason.png": 973,
	"./emblems/Bremblens-coat_of_arms.svg": 974,
	"./emblems/Bremgarten_bei_Bern-coat_of_arms.svg": 975,
	"./emblems/Brenzikofen-coat_of_arms.svg": 976,
	"./emblems/Bretigny-sur-Morrens-coat_of_arms.svg": 977,
	"./emblems/Bretonnieres-coat_of_arms.svg": 978,
	"./emblems/Brienz-coat_of_arms.svg": 979,
	"./emblems/Brienzwiler-coat_of_arms.svg": 980,
	"./emblems/BrioneSopraMinusio-coat_of_arms.svg": 981,
	"./emblems/Brissago-coat_of_arms.svg": 982,
	"./emblems/Broc-coat_of_arms.svg": 983,
	"./emblems/Brot-Plamboz-coat_of_arms.svg": 984,
	"./emblems/Bruegg-coat_of_arms.svg": 985,
	"./emblems/Bruenisried-coat_of_arms.svg": 986,
	"./emblems/Bruettelen-coat_of_arms.svg": 987,
	"./emblems/Bruetten-blazon.svg": 988,
	"./emblems/Brugg-blason.svg": 989,
	"./emblems/BrusinoArsizio-coat_of_arms.svg": 990,
	"./emblems/Brusio_wappen.svg": 991,
	"./emblems/Buch_am_Irchel-blazon.svg": 992,
	"./emblems/Buchholterberg-coat_of_arms.svg": 993,
	"./emblems/Buchillon-coat_of_arms.svg": 994,
	"./emblems/Buchrain_LU_border2.png": 995,
	"./emblems/Buchs-blazon.svg": 996,
	"./emblems/Buechegg-Blazono.png": 997,
	"./emblems/Bueetigen-coat_of_arms.svg": 998,
	"./emblems/Buehl_bei_Aarberg-coat_of_arms.svg": 999,
	"./emblems/Buehler-coat_of_arms.svg": 1000,
	"./emblems/Buelach-blazon.svg": 1001,
	"./emblems/Buerchen-coat_of_arms.svg": 1002,
	"./emblems/Bueren-blason.png": 1003,
	"./emblems/Bueren-coat_of_arms.svg": 1004,
	"./emblems/Buerglen(Turgovio)-Blazono.png": 1005,
	"./emblems/Bueron_LU.png": 1006,
	"./emblems/Buesserach-blason.png": 1007,
	"./emblems/Bulle-coat_of_arms.svg": 1008,
	"./emblems/Bullet-coat_of_arms.svg": 1009,
	"./emblems/Buochs-coat_of_arms.svg": 1010,
	"./emblems/Bure.blason.png": 1011,
	"./emblems/Burgdorf-coat_of_arms.svg": 1012,
	"./emblems/Burgistein-coat_of_arms.svg": 1013,
	"./emblems/Bursinel-coat_of_arms.svg": 1014,
	"./emblems/Bursins-coat_of_arms.svg": 1015,
	"./emblems/Burtigny-coat_of_arms.svg": 1016,
	"./emblems/Buseno_wappen.svg": 1017,
	"./emblems/Bussnang-Blazono.png": 1018,
	"./emblems/Busswil_bei_Melchnau-coat_of_arms.svg": 1019,
	"./emblems/Bussy-sur-Moudon-coat_of_arms.svg": 1020,
	"./emblems/CHE_Andelfingen_COA.svg": 1021,
	"./emblems/CHE_Arosa_COA.svg": 1022,
	"./emblems/CHE_Baltschieder_COA.svg": 1023,
	"./emblems/CHE_Basse-Vendline_COA.svg": 1024,
	"./emblems/CHE_Blonay-Saint-Legier_COA.svg": 1025,
	"./emblems/CHE_Boeztal_COA.svg": 1026,
	"./emblems/CHE_Calanca_COA.svg": 1027,
	"./emblems/CHE_Crans-Montana_COA.svg": 1028,
	"./emblems/CHE_Damphreux-Lugnez_COA.svg": 1029,
	"./emblems/CHE_Domleschg_COA.svg": 1030,
	"./emblems/CHE_Dotzigen_BE_COA.svg": 1031,
	"./emblems/CHE_Eschenbach_SG_COA.svg": 1032,
	"./emblems/CHE_Fetigny_COA.svg": 1033,
	"./emblems/CHE_Grolley-Ponthaux_COA.svg": 1034,
	"./emblems/CHE_Haute-Sorne_COA.svg": 1035,
	"./emblems/CHE_Hautemorges_COA.svg": 1036,
	"./emblems/CHE_Heimenhausen_COA.svg": 1037,
	"./emblems/CHE_Herznach-Ueken_COA.svg": 1038,
	"./emblems/CHE_Hunzenschwil_COA.svg": 1039,
	"./emblems/CHE_Koeniz_COA.svg": 1040,
	"./emblems/CHE_Latena_COA.svg": 1041,
	"./emblems/CHE_Lema_COA.svg": 1042,
	"./emblems/CHE_Lucens_COA.svg": 1043,
	"./emblems/CHE_Luesslingen-Nennigkofen_COA.svg": 1044,
	"./emblems/CHE_Muntogna_da_Schons_COA.svg": 1045,
	"./emblems/CHE_Noble-Contree_COA_alt.svg": 1046,
	"./emblems/CHE_Petit-Val_COA.svg": 1047,
	"./emblems/CHE_Prez_COA.svg": 1048,
	"./emblems/CHE_Rheinwald_COA.svg": 1049,
	"./emblems/CHE_Schwende-Ruete_COA.svg": 1050,
	"./emblems/CHE_Stalden_COA.svg": 1051,
	"./emblems/CHE_Stammheim_COA.svg": 1052,
	"./emblems/CHE_Thurnen_COA.svg": 1053,
	"./emblems/CHE_Tobel-Taegerschen_COA.svg": 1054,
	"./emblems/CHE_Tresa_COA.svg": 1055,
	"./emblems/CHE_Val_Mara_TI_COA.svg": 1056,
	"./emblems/CHE_Val_de_Bagnes_COA.svg": 1057,
	"./emblems/CHE_Valbirse_COA.svg": 1058,
	"./emblems/CHE_Verzasca_TI_COA.svg": 1059,
	"./emblems/CHE_Villaz_FR_COA.svg": 1060,
	"./emblems/CHE_Zollikon_COA.svg": 1061,
	"./emblems/CHE_Zurzach_COA.svg": 1062,
	"./emblems/CHE_Zwischbergen_COA.svg": 1063,
	"./emblems/CH_Belmont-Broye_COA.svg": 1064,
	"./emblems/CH_Gibloux_COA.svg": 1065,
	"./emblems/CH_Mont-Vully_COA.svg": 1066,
	"./emblems/Cademario-coat_of_arms.svg": 1067,
	"./emblems/Cadempino-coat_of_arms.svg": 1068,
	"./emblems/Cadenazzo-coat_of_arms.svg": 1069,
	"./emblems/Cama_wappen.svg": 1070,
	"./emblems/Campo(Vallemaggia)-coat_of_arms.svg": 1071,
	"./emblems/Canobbio-coat_of_arms.svg": 1072,
	"./emblems/Capriasca-coat_of_arms.svg": 1073,
	"./emblems/Carouge-coat_of_arms.svg": 1074,
	"./emblems/Cartigny-coat_of_arms.svg": 1075,
	"./emblems/Caslano-coat_of_arms.svg": 1076,
	"./emblems/Castaneda_wappen.svg": 1077,
	"./emblems/CastelSanPietro-coat_of_arms.svg": 1078,
	"./emblems/Cazis_wappen.svg": 1079,
	"./emblems/Celerina_Schlarigna_wappen.svg": 1080,
	"./emblems/Celigny-coat_of_arms.svg": 1081,
	"./emblems/Centovalli-coat_of_arms.png": 1082,
	"./emblems/Cerentino-coat_of_arms.svg": 1083,
	"./emblems/Cevio-coat_of_arms.svg": 1084,
	"./emblems/Chalais_VS-coat_of_arms.svg": 1085,
	"./emblems/Cham_ZG_Wappen.svg": 1086,
	"./emblems/Chamblon-coat_of_arms.svg": 1087,
	"./emblems/Chamoson-coat_of_arms.svg": 1088,
	"./emblems/Champagne_(VD)-coat_of_arms.svg": 1089,
	"./emblems/Champery.png": 1090,
	"./emblems/Champoz-coat_of_arms.svg": 1091,
	"./emblems/Champtauroz-coat_of_arms.svg": 1092,
	"./emblems/Champvent-coat_of_arms.svg": 1093,
	"./emblems/Chancy-coat_of_arms.svg": 1094,
	"./emblems/Chardonne-coat_of_arms.svg": 1095,
	"./emblems/Chateau-dOex-coat_of_arms.svg": 1096,
	"./emblems/Chatel-Saint-Denis-coat_of_arms.svg": 1097,
	"./emblems/Chatel-sur-Montsalvens-coat_of_arms.svg": 1098,
	"./emblems/Chatillon-Blazono.png": 1099,
	"./emblems/Chatillon.png": 1100,
	"./emblems/Chatonnaye-coat_of_arms.svg": 1101,
	"./emblems/Chavannes-de-Bogis-coat_of_arms.svg": 1102,
	"./emblems/Chavannes-des-Bois-coat_of_arms.svg": 1103,
	"./emblems/Chavannes-le-Chene-coat_of_arms.svg": 1104,
	"./emblems/Chavannes-le-Veyron-coat_of_arms.svg": 1105,
	"./emblems/Chavornay-coat_of_arms.svg": 1106,
	"./emblems/Chene-Paquier-coat_of_arms.svg": 1107,
	"./emblems/CheneBougeries-coat_of_arms.svg": 1108,
	"./emblems/CheneBourg-coat_of_arms.svg": 1109,
	"./emblems/Chenens-coat_of_arms.svg": 1110,
	"./emblems/Cheseaux-Noreaz-coat_of_arms.svg": 1111,
	"./emblems/Cheseaux-sur-Lausanne-coat_of_arms.svg": 1112,
	"./emblems/Cheserex-coat_of_arms.svg": 1113,
	"./emblems/Chessel-coat_of_arms.svg": 1114,
	"./emblems/Chevilly-coat_of_arms.svg": 1115,
	"./emblems/Chevroux.png": 1116,
	"./emblems/Chexbres-coat_of_arms.svg": 1117,
	"./emblems/Chiasso-coat_of_arms.svg": 1118,
	"./emblems/Chigny-coat_of_arms.svg": 1119,
	"./emblems/Chippis.png": 1120,
	"./emblems/Choulex-coat_of_arms.svg": 1121,
	"./emblems/Chur_wappen.svg": 1122,
	"./emblems/City_of_Fribourg-coat_of_arms.svg": 1123,
	"./emblems/Clarmont-coat_of_arms.svg": 1124,
	"./emblems/Coa_Switzerland_Town_Waldenburg.svg": 1125,
	"./emblems/Coa_stgallen.svg": 1126,
	"./emblems/Coat_Diepoldsau.gif": 4051,
	"./emblems/Coat_of_arms_of_Aesch_BL.svg": 1127,
	"./emblems/Coat_of_arms_of_Anwil.svg": 1128,
	"./emblems/Coat_of_arms_of_Arboldswil.svg": 1129,
	"./emblems/Coat_of_arms_of_Arlesheim.svg": 1130,
	"./emblems/Coat_of_arms_of_Auenstein_AG.svg": 1131,
	"./emblems/Coat_of_arms_of_Baden_AG.svg": 1132,
	"./emblems/Coat_of_arms_of_Beinwil_am_See.svg": 1133,
	"./emblems/Coat_of_arms_of_Biel-Benken.svg": 1134,
	"./emblems/Coat_of_arms_of_Binningen_BL.svg": 1135,
	"./emblems/Coat_of_arms_of_Birsfelden.svg": 1136,
	"./emblems/Coat_of_arms_of_Blauen_BL.svg": 1137,
	"./emblems/Coat_of_arms_of_Boeckten.svg": 1138,
	"./emblems/Coat_of_arms_of_Boettstein.svg": 1139,
	"./emblems/Coat_of_arms_of_Bottmingen.svg": 1140,
	"./emblems/Coat_of_arms_of_Bretzwil.svg": 1141,
	"./emblems/Coat_of_arms_of_Brislach.svg": 1142,
	"./emblems/Coat_of_arms_of_Brittnau.svg": 1143,
	"./emblems/Coat_of_arms_of_Bubendorf_BL.svg": 1144,
	"./emblems/Coat_of_arms_of_Buckten.svg": 1145,
	"./emblems/Coat_of_arms_of_Burg_im_Leimental.svg": 1146,
	"./emblems/Coat_of_arms_of_Buttisholz.svg": 1147,
	"./emblems/Coat_of_arms_of_Buus.svg": 1148,
	"./emblems/Coat_of_arms_of_Diepflingen.svg": 1149,
	"./emblems/Coat_of_arms_of_Doettingen_AG.svg": 1150,
	"./emblems/Coat_of_arms_of_Ennetbaden.svg": 1151,
	"./emblems/Coat_of_arms_of_Erlinsbach_AG.svg": 1152,
	"./emblems/Coat_of_arms_of_Ettingen.svg": 1153,
	"./emblems/Coat_of_arms_of_Fislisbach.svg": 1154,
	"./emblems/Coat_of_arms_of_Gelterkinden.svg": 1155,
	"./emblems/Coat_of_arms_of_Giebenach.svg": 1156,
	"./emblems/Coat_of_arms_of_Hemmiken.svg": 1157,
	"./emblems/Coat_of_arms_of_Hersberg.svg": 1158,
	"./emblems/Coat_of_arms_of_Holziken.svg": 1159,
	"./emblems/Coat_of_arms_of_Kienberg_SO.svg": 1160,
	"./emblems/Coat_of_arms_of_Kilchberg_BL.svg": 1161,
	"./emblems/Coat_of_arms_of_Killwangen.svg": 1162,
	"./emblems/Coat_of_arms_of_Lampenberg.svg": 1163,
	"./emblems/Coat_of_arms_of_Lausen_BL.svg": 1164,
	"./emblems/Coat_of_arms_of_Lauwil.svg": 1165,
	"./emblems/Coat_of_arms_of_Leibstadt.svg": 1166,
	"./emblems/Coat_of_arms_of_Leimbach_AG.svg": 1167,
	"./emblems/Coat_of_arms_of_Lenzburg.svg": 1168,
	"./emblems/Coat_of_arms_of_Leuggern.svg": 1169,
	"./emblems/Coat_of_arms_of_Liestal.svg": 1170,
	"./emblems/Coat_of_arms_of_Maisprach.svg": 1171,
	"./emblems/Coat_of_arms_of_Meisterschwanden.svg": 1172,
	"./emblems/Coat_of_arms_of_Menziken.svg": 1173,
	"./emblems/Coat_of_arms_of_Metzerlen-Mariastein.svg": 1174,
	"./emblems/Coat_of_arms_of_Moenthal.svg": 1175,
	"./emblems/Coat_of_arms_of_Neuenhof_AG.svg": 1176,
	"./emblems/Coat_of_arms_of_Niederdorf_BL.svg": 1177,
	"./emblems/Coat_of_arms_of_Niederwil_AG.svg": 1178,
	"./emblems/Coat_of_arms_of_Nottwil.svg": 1179,
	"./emblems/Coat_of_arms_of_Nusshof.svg": 1180,
	"./emblems/Coat_of_arms_of_Oberdorf_BL.svg": 1181,
	"./emblems/Coat_of_arms_of_Oberkulm.svg": 1182,
	"./emblems/Coat_of_arms_of_Oberwil_BL.svg": 1183,
	"./emblems/Coat_of_arms_of_Oeschgen.svg": 1184,
	"./emblems/Coat_of_arms_of_Oftringen.svg": 1185,
	"./emblems/Coat_of_arms_of_Olsberg_AG.svg": 1186,
	"./emblems/Coat_of_arms_of_Oltingen.svg": 1187,
	"./emblems/Coat_of_arms_of_Ormalingen.svg": 1188,
	"./emblems/Coat_of_arms_of_Pfeffingen_BL.svg": 1189,
	"./emblems/Coat_of_arms_of_Ramlinsburg.svg": 1190,
	"./emblems/Coat_of_arms_of_Reinach_AG.svg": 1191,
	"./emblems/Coat_of_arms_of_Reinach_BL.svg": 1192,
	"./emblems/Coat_of_arms_of_Rheinfelden_AG.svg": 1193,
	"./emblems/Coat_of_arms_of_Rickenbach_BL.svg": 1194,
	"./emblems/Coat_of_arms_of_Rothenfluh.svg": 1195,
	"./emblems/Coat_of_arms_of_Ruenenberg.svg": 1196,
	"./emblems/Coat_of_arms_of_Rupperswil.svg": 1197,
	"./emblems/Coat_of_arms_of_Schenkon.svg": 1198,
	"./emblems/Coat_of_arms_of_Schneisingen.svg": 1199,
	"./emblems/Coat_of_arms_of_Schoeftland.svg": 1200,
	"./emblems/Coat_of_arms_of_Schwaderloch.svg": 1201,
	"./emblems/Coat_of_arms_of_Seltisberg.svg": 1202,
	"./emblems/Coat_of_arms_of_Stetten_AG.svg": 1203,
	"./emblems/Coat_of_arms_of_Strengelbach.svg": 1204,
	"./emblems/Coat_of_arms_of_Tecknau.svg": 1205,
	"./emblems/Coat_of_arms_of_Tenniken.svg": 1206,
	"./emblems/Coat_of_arms_of_Teufenthal.svg": 1207,
	"./emblems/Coat_of_arms_of_Thuernen.svg": 1208,
	"./emblems/Coat_of_arms_of_Uerkheim.svg": 1209,
	"./emblems/Coat_of_arms_of_Uezwil.svg": 1210,
	"./emblems/Coat_of_arms_of_Unterkulm.svg": 1211,
	"./emblems/Coat_of_arms_of_Unterlunkhofen.svg": 1212,
	"./emblems/Coat_of_arms_of_Villmergen.svg": 1213,
	"./emblems/Coat_of_arms_of_Wallbach_AG.svg": 1214,
	"./emblems/Coat_of_arms_of_Waltenschwil.svg": 1215,
	"./emblems/Coat_of_arms_of_Wenslingen.svg": 1216,
	"./emblems/Coat_of_arms_of_Wettingen.svg": 1217,
	"./emblems/Coat_of_arms_of_Wintersingen.svg": 1218,
	"./emblems/Coat_of_arms_of_Wittinsburg.svg": 1219,
	"./emblems/Coat_of_arms_of_Wohlen_AG.svg": 1220,
	"./emblems/Coat_of_arms_of_Zeglingen.svg": 1221,
	"./emblems/Coat_of_arms_of_Zofingen.svg": 1222,
	"./emblems/Coat_of_arms_of_Zunzgen.svg": 1223,
	"./emblems/Coat_of_arms_of_Zwingen.svg": 1224,
	"./emblems/Coats_of_arms_of_None.svg": 1225,
	"./emblems/Coeuve.png": 1226,
	"./emblems/Coinsins-coat_of_arms.svg": 1227,
	"./emblems/Coldrerio-coat_of_arms.svg": 1228,
	"./emblems/CollexBossy-coat_of_arms.svg": 1229,
	"./emblems/Collinadoro_stemma_colori.svg": 1230,
	"./emblems/Collombeymuraz.png": 1231,
	"./emblems/CollongeBellerive-coat_of_arms.svg": 1232,
	"./emblems/Collonges_VS-coat_of_arms.svg": 1233,
	"./emblems/Cologny-coat_of_arms.svg": 1234,
	"./emblems/Comano-coat_of_arms.svg": 1235,
	"./emblems/Commugny-coat_of_arms.svg": 1236,
	"./emblems/Commune_de_Villeneuve_(VD).svg": 1237,
	"./emblems/Concise-coat_of_arms.svg": 1238,
	"./emblems/Confignon-coat_of_arms.svg": 1239,
	"./emblems/Conters_i_P_wappen.svg": 1240,
	"./emblems/Conthey.png": 1241,
	"./emblems/Coppet-coat_of_arms.svg": 1242,
	"./emblems/Corbieres_FR-coat_of_arms.svg": 1243,
	"./emblems/Corcelles-BE-coat-of-arms.svg": 1244,
	"./emblems/Corcelles-le-Jorat-coat_of_arms.svg": 1245,
	"./emblems/Corcelles-pres-Concise-coat_of_arms.svg": 1246,
	"./emblems/Corgemont-coat_of_arms.svg": 1247,
	"./emblems/Corminboeuf-coat_of_arms.svg": 1248,
	"./emblems/Cormoret-coat_of_arms.svg": 1249,
	"./emblems/Cornol.png": 1250,
	"./emblems/Corseaux-coat_of_arms.svg": 1251,
	"./emblems/Corsier-coat_of_arms.svg": 1252,
	"./emblems/Corsier-sur-Vevey-coat_of_arms.svg": 1253,
	"./emblems/Cortaillod-blason.png": 1254,
	"./emblems/Cortebert-coat_of_arms.svg": 1255,
	"./emblems/Cossonay-coat_of_arms.svg": 1256,
	"./emblems/Cote-aux-fees.png": 1257,
	"./emblems/Cottens-coat_of_arms.svg": 1258,
	"./emblems/Courchapoix-Blazono.png": 1259,
	"./emblems/Courchavon-coat_of_arms.svg": 1260,
	"./emblems/Courgena.png": 1261,
	"./emblems/Courgevaux-coat_of_arms.svg": 1262,
	"./emblems/Courrendlin.png": 1263,
	"./emblems/Courroux-coat_of_arms.svg": 1264,
	"./emblems/Court-coat_of_arms.svg": 1265,
	"./emblems/Courtedoux.ch.png": 1266,
	"./emblems/Courtelary-coat_of_arms.svg": 1267,
	"./emblems/Courtepin2-coat_of_arms.svg": 1268,
	"./emblems/Courtetelle-blason.png": 1269,
	"./emblems/Crans-pres-Celigny-coat_of_arms.svg": 1270,
	"./emblems/Crassier-coat_of_arms.svg": 1271,
	"./emblems/Cremines-coat_of_arms.svg": 1272,
	"./emblems/Cressier-FR-coat_of_arms.svg": 1273,
	"./emblems/Cressier_NE-coat_of_arms.svg": 1274,
	"./emblems/Cresuz-coat_of_arms.svg": 1275,
	"./emblems/Cronay-coat_of_arms.svg": 1276,
	"./emblems/Croy-coat_of_arms.svg": 1277,
	"./emblems/Cuarnens-coat_of_arms.svg": 1278,
	"./emblems/Cuarny-coat_of_arms.svg": 1279,
	"./emblems/Cugy-VD-coat_of_arms.svg": 1280,
	"./emblems/Cureglia-coat_of_arms.svg": 1281,
	"./emblems/Curtilles-coat_of_arms.svg": 1282,
	"./emblems/Dachsen-blazon.svg": 1283,
	"./emblems/Daegerlen-blazon.svg": 1284,
	"./emblems/Daellikon-blazon.svg": 1285,
	"./emblems/Daeniken-blason.png": 1286,
	"./emblems/Daenikon-blazon.svg": 1287,
	"./emblems/Daerligen-coat_of_arms.svg": 1288,
	"./emblems/Daerstetten-coat_of_arms.svg": 1289,
	"./emblems/Daettlikon-blazon.svg": 1290,
	"./emblems/Dagmersellen_LU.png": 1291,
	"./emblems/Daillens-coat_of_arms.svg": 1292,
	"./emblems/Dallenwil-coat_of_arms.svg": 1293,
	"./emblems/Dalpe-coat_of_arms.svg": 1294,
	"./emblems/Dardagny-coat_of_arms.svg": 1295,
	"./emblems/Davos_wappen.svg": 1296,
	"./emblems/Degersheim-coat_of_arms.svg": 1297,
	"./emblems/Deisswil_bei_Muenchenbuchsee-coat_of_arms.svg": 1298,
	"./emblems/Deitingen-blason.png": 1299,
	"./emblems/Delemont_coat_of_arms.svg": 1300,
	"./emblems/Delley-Portalban-coat_of_arms.svg": 1301,
	"./emblems/Demoret-coat_of_arms.svg": 1302,
	"./emblems/Denens-coat_of_arms.svg": 1303,
	"./emblems/Denges-coat_of_arms.svg": 1304,
	"./emblems/Derendingen-blason.png": 1305,
	"./emblems/Develier-coat_of_arms.svg": 1306,
	"./emblems/Dielsdorf-blazon.svg": 1307,
	"./emblems/Diemtigen-coat_of_arms.svg": 1308,
	"./emblems/Dierikon_LU.png": 1309,
	"./emblems/Diessbach_bei_Bueren-coat_of_arms.svg": 1310,
	"./emblems/Diessenhofen.png": 1311,
	"./emblems/Dietikon-blazon.svg": 1312,
	"./emblems/Dietlikon-blazon.svg": 1313,
	"./emblems/Dinhard-blazon.svg": 1314,
	"./emblems/Disentis_Muster_wappen.svg": 1315,
	"./emblems/Dizy-coat_of_arms.svg": 1316,
	"./emblems/Domat_Ems_wappen.svg": 1317,
	"./emblems/Dompierre-drapeau.png": 1318,
	"./emblems/Donneloye-coat_of_arms.svg": 1319,
	"./emblems/Doppleschwand_LU.png": 1320,
	"./emblems/Dorenaz.png": 1321,
	"./emblems/Dorf-blazon.svg": 1322,
	"./emblems/Dorneck.png": 1323,
	"./emblems/DreiHoefe-blazon.svg": 1324,
	"./emblems/Duebendorf-blazon.svg": 1325,
	"./emblems/Duedingen-coat_of_arms.svg": 1326,
	"./emblems/Duernten-blazon.svg": 1327,
	"./emblems/Duerrenroth-coat_of_arms.svg": 1328,
	"./emblems/Duillier-coat_of_arms.svg": 1329,
	"./emblems/Dulliken-blason.png": 1330,
	"./emblems/Dully-coat_of_arms.svg": 1331,
	"./emblems/Ebikon_LU.png": 1332,
	"./emblems/Echallens-coat_of_arms.svg": 1333,
	"./emblems/Echandens-coat_of_arms.svg": 1334,
	"./emblems/Echarlens-coat_of_arms.svg": 1335,
	"./emblems/Echichens_2011-coat_of_arms.svg": 1336,
	"./emblems/Eclepens-coat_of_arms.svg": 1337,
	"./emblems/Ecubasseallaine.png": 1338,
	"./emblems/Ederswiler-Blazono.png": 1339,
	"./emblems/Egerkingen-blason.png": 1340,
	"./emblems/Egg-blazon-variant.svg": 1341,
	"./emblems/Eggersri.png": 1342,
	"./emblems/Eggiwil-coat_of_arms.svg": 1343,
	"./emblems/Eglisau-blazon.svg": 1344,
	"./emblems/Egnach-coat_of_arms.svg": 1345,
	"./emblems/Egolzwil_LU.png": 1346,
	"./emblems/Eich_LU.png": 1347,
	"./emblems/Eichberg-coat_of_arms.svg": 1348,
	"./emblems/Einsiedeln-coat_of_arms.svg": 1349,
	"./emblems/Eischoll-coat_of_arms.svg": 1350,
	"./emblems/Eisten_Wappen.png": 1351,
	"./emblems/Elgg-blazon.svg": 1352,
	"./emblems/Ellikon_an_der_Thur-blazon.svg": 1353,
	"./emblems/Elsau-blazon.svg": 1354,
	"./emblems/Embd_Wappen.png": 1355,
	"./emblems/Emblem_village_Wigoltingen.png": 1356,
	"./emblems/Embrach-blazon.svg": 1357,
	"./emblems/Emmen_LU.png": 1358,
	"./emblems/Emmetten-coat_of_arms.svg": 1359,
	"./emblems/Engelberg-coat_of_arms_-_2.png": 1360,
	"./emblems/Ennetburgen-coat_of_arms.svg": 1361,
	"./emblems/Ennetmoos-coat_of_arms.svg": 1362,
	"./emblems/Entlebuch_LU.png": 1363,
	"./emblems/Epalinges-coat_of_arms.svg": 1364,
	"./emblems/Ependes-coat_of_arms.svg": 1365,
	"./emblems/Eppenberg-blason.png": 1366,
	"./emblems/Epsach-coat_of_arms.svg": 1367,
	"./emblems/Ergisch_Wappen.png": 1368,
	"./emblems/Eriswil-coat_of_arms.svg": 1369,
	"./emblems/Eriz-coat_of_arms.svg": 1370,
	"./emblems/Erlach-coat_of_arms.svg": 1371,
	"./emblems/Erlen-Blazono.png": 1372,
	"./emblems/Erlenbach_ZH-coat_of_arms.svg": 1373,
	"./emblems/Erlenbach_im_Simmental-coat_of_arms.svg": 1374,
	"./emblems/Erlinsbach_SO-blason.png": 1375,
	"./emblems/Ermatingen-blazon.svg": 1376,
	"./emblems/Ermensee_LU.png": 1377,
	"./emblems/Ernen-coat_of_arms.svg": 1378,
	"./emblems/Erschwil-blason.png": 1379,
	"./emblems/Ersigen-coat_of_arms.svg": 1380,
	"./emblems/Eschenbach_LU.png": 1381,
	"./emblems/Eschenz.GIF": 4052,
	"./emblems/Eschert-coat_of_arms.svg": 1382,
	"./emblems/Eschlikon(Turgovio)-Blazono.png": 1383,
	"./emblems/Escholzmatt_LU.png": 1384,
	"./emblems/Essertines-sur-Rolle-coat_of_arms.svg": 1385,
	"./emblems/Essertines-sur-Yverdon-coat_of_arms.svg": 1386,
	"./emblems/Etoy-coat_of_arms.svg": 1387,
	"./emblems/Ettiswil_LU.png": 1388,
	"./emblems/Etziken-blason.png": 1389,
	"./emblems/Evilard-coat_of_arms.svg": 1390,
	"./emblems/Evolene-coat_of_arms.png": 1391,
	"./emblems/Eysins-coat_of_arms.svg": 1392,
	"./emblems/Faellanden-blazon.svg": 1393,
	"./emblems/Fahrni_blason1.svg": 1394,
	"./emblems/Fahy.Jura.CH.png": 1395,
	"./emblems/Faido-coat_of_arms.svg": 1396,
	"./emblems/Falera_wappen.svg": 1397,
	"./emblems/Faoug-coat_of_arms.svg": 1398,
	"./emblems/Farnern-coat_of_arms.svg": 1399,
	"./emblems/Fechy-coat_of_arms.svg": 1400,
	"./emblems/Fehraltorf-blazon.svg": 1401,
	"./emblems/Fehren-blason.png": 1402,
	"./emblems/Felben-Wellhausen-Blazono.png": 1403,
	"./emblems/Feldbrunnen-StNiklaus-blason.png": 1404,
	"./emblems/Felsberg_wappen.svg": 1405,
	"./emblems/Ferden.png": 1406,
	"./emblems/Ferenbalm-coat_of_arms.svg": 1407,
	"./emblems/Ferpicloz-coat_of_arms.svg": 1408,
	"./emblems/Ferreyres-coat_of_arms.svg": 1409,
	"./emblems/Feuerthalen-blazon.svg": 1410,
	"./emblems/Fideris_wappen.svg": 1411,
	"./emblems/Fiesch-coat_of_arms.svg": 1412,
	"./emblems/Fiez-coat_of_arms.svg": 1413,
	"./emblems/Finhaut.wappen.png": 1414,
	"./emblems/Finsterhennen-coat_of_arms.svg": 1415,
	"./emblems/Fischbach_LU.png": 1416,
	"./emblems/Fischenthal-blazon.svg": 1417,
	"./emblems/Fischingen(Turgovio)-Blazono.png": 1418,
	"./emblems/Flaach-blazon.svg": 1419,
	"./emblems/Flaesch_wappen.svg": 1420,
	"./emblems/Flag_of_Val_Terbi.png": 1421,
	"./emblems/Flerden_wappen.svg": 1422,
	"./emblems/Flims_wappen.svg": 1423,
	"./emblems/Flueelen-coat_of_arms.svg": 1424,
	"./emblems/Fluehli_LU.png": 1425,
	"./emblems/Flumenthal-blason.png": 1426,
	"./emblems/Flurlingen-blazon.svg": 1427,
	"./emblems/Fontaines-sur-Grandson-coat_of_arms.svg": 1428,
	"./emblems/Fontenais-Blazono.png": 1429,
	"./emblems/Forel-coat_of_arms.svg": 1430,
	"./emblems/Forst_Laengenbuehl-coat_of_arms.svg": 1431,
	"./emblems/Founex-coat_of_arms.svg": 1432,
	"./emblems/Fraeschels-coat_of_arms.svg": 1433,
	"./emblems/Fraubrunnen-coat_of_arms.svg": 1434,
	"./emblems/Frauenfeld-coat_of_arms.png": 1435,
	"./emblems/Frauenkappelen-coat_of_arms.svg": 1436,
	"./emblems/Freienstein-Teufen-blazon.svg": 1437,
	"./emblems/Freimettigen-coat_of_arms.svg": 1438,
	"./emblems/Froideville-coat_of_arms.svg": 1439,
	"./emblems/Frutigen-coat_of_arms.svg": 1440,
	"./emblems/Fuerstenau_wappen.svg": 1441,
	"./emblems/Fulenbach-blason.png": 1442,
	"./emblems/Fullywappen.png": 1443,
	"./emblems/Furna_wappen.svg": 1444,
	"./emblems/GW-BE-Plateau-de-Diesse.png": 1445,
	"./emblems/GW-FR-Botterens_neu.png": 1446,
	"./emblems/GW-FR-Cugy_neu.png": 1447,
	"./emblems/GW-FR-Le-Mouret.png": 1448,
	"./emblems/GW-FR-Les-Montets.png": 1449,
	"./emblems/GW-FR-Lully_neu.png": 1450,
	"./emblems/GW-FR-Posat.png": 1451,
	"./emblems/GW-FR-Siviriez_neu.png": 1452,
	"./emblems/GW-FR-Vuisternens-devant-Romont_neu.png": 1453,
	"./emblems/GW-GL-Glarus_Nord.png": 1454,
	"./emblems/GW-GL-Glarus_Sued.png": 1455,
	"./emblems/GW-GL-Glarus_neu.png": 1456,
	"./emblems/GW-GR-Churwalden_neu.png": 1457,
	"./emblems/GW-GR-Ferrera.png": 1458,
	"./emblems/GW-JU-Clos_du_Doubs.png": 1459,
	"./emblems/GW-NE-Val-de-Travers.png": 1460,
	"./emblems/GW-SG-Buetschwil-Ganterschwil.png": 1461,
	"./emblems/GW-SG-Ebnat-Kappel.png": 1462,
	"./emblems/GW-SG-Neckertal.png": 1463,
	"./emblems/GW-SG-Wildhaus-Alt_Sankt_Johann.png": 1464,
	"./emblems/GW-TG-Kemmental.png": 1465,
	"./emblems/GW-TG-Kradolf-Schoenenberg.png": 1466,
	"./emblems/GW-TG-Muensterlingen.svg": 1467,
	"./emblems/GW-TG-Schlatt.png": 1468,
	"./emblems/GW-TG-Uesslingen-Buch.png": 1469,
	"./emblems/GW-VD-Villarzel.png": 1470,
	"./emblems/GW-VS-Moerel-Filet.png": 1471,
	"./emblems/GX-VD-Syens.png": 1472,
	"./emblems/GX-VD-Villars-le-Comte.png": 1473,
	"./emblems/GX-VS-Verossaz.png": 1474,
	"./emblems/Gachnang-Blazono.png": 1475,
	"./emblems/Gais-coat_of_arms.svg": 1476,
	"./emblems/Gaiserwald-blazono.png": 1477,
	"./emblems/Gals-coat_of_arms.svg": 1478,
	"./emblems/Gambarogno_CoA.png": 1479,
	"./emblems/Gampelen-coat_of_arms.svg": 1480,
	"./emblems/GamsSG.png": 1481,
	"./emblems/Gemeinde_Buchs-coat_of_arms.svg": 1482,
	"./emblems/Gemeindewappen-Brig-Glis.gif": 4053,
	"./emblems/GemeindewappenNiedergesteln_jpeg.png": 1483,
	"./emblems/Gemeindewappen_Konolfingen.png": 1484,
	"./emblems/Gempen-blason.png": 1485,
	"./emblems/Genolier-coat_of_arms.svg": 1486,
	"./emblems/Genthod-coat_of_arms.svg": 1487,
	"./emblems/Gerlafingen-blason.png": 1488,
	"./emblems/Geroldswil-blazon.svg": 1489,
	"./emblems/Gerzensee-coat_of_arms.svg": 1490,
	"./emblems/Geuensee_LU.png": 1491,
	"./emblems/Giez-coat_of_arms.svg": 1492,
	"./emblems/Giffers-coat_of_arms.svg": 1493,
	"./emblems/Gilly-coat_of_arms.svg": 1494,
	"./emblems/Gimel-coat_of_arms.svg": 1495,
	"./emblems/Gingins-coat_of_arms.svg": 1496,
	"./emblems/Giornico-coat_of_arms.svg": 1497,
	"./emblems/Gisikon_LU.png": 1498,
	"./emblems/Giswil-coat_of_arms.svg": 1499,
	"./emblems/Givisiez-coat_of_arms.svg": 1500,
	"./emblems/Givrins-coat_of_arms.svg": 1501,
	"./emblems/Gland-coat_of_arms.svg": 1502,
	"./emblems/Glattfelden-blazon.svg": 1503,
	"./emblems/Gletterens-coat_of_arms.svg": 1504,
	"./emblems/Goeschenen-coat_of_arms.svg": 1505,
	"./emblems/Goldach.png": 1506,
	"./emblems/Gollion-coat_of_arms.svg": 1507,
	"./emblems/Gommiswald-blazono.png": 1508,
	"./emblems/Goms_(district)-coat_of_arms.svg": 1509,
	"./emblems/Gondiswil-coat_of_arms.svg": 1510,
	"./emblems/Gonten-Wappen.png": 1511,
	"./emblems/Gordola-coat_of_arms.svg": 1512,
	"./emblems/Gossau-blazon.svg": 1513,
	"./emblems/Gossau_wappen_gross.png": 1514,
	"./emblems/Gottlieben.GIF": 4054,
	"./emblems/Goumoens-coat_of_arms.svg": 1515,
	"./emblems/Graben-coat_of_arms.svg": 1516,
	"./emblems/GrabsSG.png": 1517,
	"./emblems/Graechen_Wappen.png": 1518,
	"./emblems/Grancia-coat_of_arms.svg": 1519,
	"./emblems/Grancy-coat_of_arms.svg": 1520,
	"./emblems/GrandSaconnex-coat_of_arms.svg": 1521,
	"./emblems/Grandcour-coat_of_arms.svg": 1522,
	"./emblems/Grandevent-coat_of_arms.svg": 1523,
	"./emblems/Grandfontaine-coat_of_arms.svg": 1524,
	"./emblems/Grandson-coat_of_arms.svg": 1525,
	"./emblems/Grandval-coat_of_arms.svg": 1526,
	"./emblems/Grandvillard-coat_of_arms.svg": 1527,
	"./emblems/Granges-Paccot-coat_of_arms.svg": 1528,
	"./emblems/Granges-coat_of_arms.svg": 1529,
	"./emblems/Grangettes-coat_of_arms.svg": 1530,
	"./emblems/Gravesano-coat_of_arms.svg": 1531,
	"./emblems/Greifensee-blazon.svg": 1532,
	"./emblems/Grellingen_coat_of_arms.svg": 1533,
	"./emblems/Grenchen-blason.png": 1534,
	"./emblems/Greng-coat_of_arms.svg": 1535,
	"./emblems/Grens-coat_of_arms.svg": 1536,
	"./emblems/Greppen_LU.png": 1537,
	"./emblems/Gretzenbach-blason.png": 1538,
	"./emblems/Grimisuat.png": 1539,
	"./emblems/Grindel-blason.png": 1540,
	"./emblems/Grindelwald-coat_of_arms.svg": 1541,
	"./emblems/Grone.png": 1542,
	"./emblems/Grono_wappen.svg": 1543,
	"./emblems/Grossaffoltern-coat_of_arms.svg": 1544,
	"./emblems/Grossdietwil_LU.png": 1545,
	"./emblems/Grosshoechstetten-coat_of_arms.svg": 1546,
	"./emblems/Grosswangen_LU.png": 1547,
	"./emblems/Grubar.png": 1548,
	"./emblems/Grueningen-blazon.svg": 1549,
	"./emblems/Gruesch_wappen.svg": 1550,
	"./emblems/Gruyeres-coat_of_arms.svg": 1551,
	"./emblems/Gsteig_bei_Gstaad-coat_of_arms.svg": 1552,
	"./emblems/Gsteigwiler-coat_of_arms.svg": 1553,
	"./emblems/Guendlischwand-coat_of_arms.svg": 1554,
	"./emblems/Guensberg-blason.png": 1555,
	"./emblems/Guettingen-Blazono.png": 1556,
	"./emblems/Guggisberg-coat_of_arms.svg": 1557,
	"./emblems/Gunzgen-blason.png": 1558,
	"./emblems/Gurbrue-coat_of_arms.svg": 1559,
	"./emblems/Gurmels-coat_of_arms.svg": 1560,
	"./emblems/Gurtnellen_Wappen.svg": 1561,
	"./emblems/Gurzelen-coat_of_arms.svg": 1562,
	"./emblems/Guttannen-coat_of_arms.svg": 1563,
	"./emblems/Guttetfeschel.png": 1564,
	"./emblems/Gy-coat_of_arms.svg": 1565,
	"./emblems/HUNDW_F.png": 1566,
	"./emblems/Habkern-coat_of_arms.svg": 1567,
	"./emblems/Haefelfingen-coat_of_arms.png": 1568,
	"./emblems/Haegendorf-blason.png": 1569,
	"./emblems/Haeggenschwil.png": 1570,
	"./emblems/Haerkingen-blason.png": 1571,
	"./emblems/Haeutligen-coat_of_arms.svg": 1572,
	"./emblems/Hagenbuch-blazon.svg": 1573,
	"./emblems/Hagneck-coat_of_arms.svg": 1574,
	"./emblems/Hasle_LU.png": 1575,
	"./emblems/Hasle_bei_Burgdorf-coat_of_arms.svg": 1576,
	"./emblems/Hasliberg-coat_of_arms.svg": 1577,
	"./emblems/Hauenstein-Ifenthal-blason.png": 1578,
	"./emblems/HauptwilGottshaus-blazon.svg": 1579,
	"./emblems/Hausen_am_Albis-blazon.svg": 1580,
	"./emblems/Haut-Intyamon-coat_of_arms.svg": 1581,
	"./emblems/Hauterive-FR-coat_of_arms.svg": 1582,
	"./emblems/Hauteville-coat_of_arms.svg": 1583,
	"./emblems/Hedingen-blazon.svg": 1584,
	"./emblems/Hefenhofen-Blazono.png": 1585,
	"./emblems/Heiligenschwendi-coat_of_arms.svg": 1586,
	"./emblems/Heimberg-coat_of_arms.svg": 1587,
	"./emblems/Heimiswil-coat_of_arms.svg": 1588,
	"./emblems/Heitenried-coat_of_arms.svg": 1589,
	"./emblems/Hellsau-coat_of_arms.svg": 1590,
	"./emblems/Henggart-blazon.svg": 1591,
	"./emblems/Herbetswil-blason.png": 1592,
	"./emblems/Herbligen-coat_of_arms.svg": 1593,
	"./emblems/Herdern.gif": 4055,
	"./emblems/Heremence-coat_of_arms.svg": 1594,
	"./emblems/Hergiswil-coat_of_arms.svg": 1595,
	"./emblems/Hergiswil_LU.png": 1596,
	"./emblems/Herisau_gemeinde.png": 1597,
	"./emblems/Hermance-coat_of_arms.svg": 1598,
	"./emblems/Hermenches.png": 1599,
	"./emblems/Hermrigen-coat_of_arms.svg": 1600,
	"./emblems/Herrliberg-blazon.svg": 1601,
	"./emblems/Herzogenbuchsee-coat_of_arms.svg": 1602,
	"./emblems/Hettlingen-blazon.svg": 1603,
	"./emblems/Hildisrieden_LU.png": 1604,
	"./emblems/Hilterfingen-coat_of_arms.svg": 1605,
	"./emblems/Himmelried-blason.png": 1606,
	"./emblems/Hindelbank-coat_of_arms.svg": 1607,
	"./emblems/Hinwil-blazon.svg": 1608,
	"./emblems/Hittnau-blazon.svg": 1609,
	"./emblems/Hitzkirch_LU.png": 1610,
	"./emblems/Hochdorf_LU.png": 1611,
	"./emblems/Hochfelden-blazon.svg": 1612,
	"./emblems/Hochwald-blason.png": 1613,
	"./emblems/Hoechstetten-coat_of_arms.svg": 1614,
	"./emblems/Hoeri-blazon.svg": 1615,
	"./emblems/Hofstetten-Flueh-blason.png": 1616,
	"./emblems/Hofstetten_bei_Brienz-coat_of_arms.svg": 1617,
	"./emblems/Hohenrain_LU.png": 1618,
	"./emblems/Hohentannen-Blazono.png": 1619,
	"./emblems/Holderbank_SO-blason.png": 1620,
	"./emblems/Homberg-coat_of_arms.svg": 1621,
	"./emblems/Hombrechtikon-blazon.svg": 1622,
	"./emblems/Homburg_neu.png": 1623,
	"./emblems/Horgen-blazon.svg": 1624,
	"./emblems/Horrenbach_Buchen-coat_of_arms.svg": 1625,
	"./emblems/Horriwil-blason.png": 1626,
	"./emblems/Horw_LU.png": 1627,
	"./emblems/Hubersdorf-blason.png": 1628,
	"./emblems/Huenenberg_Wappen.svg": 1629,
	"./emblems/Hueniken-blason.png": 1630,
	"./emblems/Huentwangen-blazon.svg": 1631,
	"./emblems/Huettikon-blazon.svg": 1632,
	"./emblems/Huettlingen-Turgovio-Blazono.png": 1633,
	"./emblems/Huettwilen.gif": 4056,
	"./emblems/Huttwil-coat_of_arms.svg": 1634,
	"./emblems/Iffwil-coat_of_arms.svg": 1635,
	"./emblems/Ilanz_wappen.svg": 1636,
	"./emblems/Illnau-Effretikon-blazon.svg": 1637,
	"./emblems/Inden_VS.png": 1638,
	"./emblems/Inkwil-coat_of_arms.svg": 1639,
	"./emblems/Innertkirchen-coat_of_arms.svg": 1640,
	"./emblems/Ins-coat_of_arms.svg": 1641,
	"./emblems/Interlaken-coat_of_arms.svg": 1642,
	"./emblems/Inwil_LU.png": 1643,
	"./emblems/Ipsach-coat_of_arms.svg": 1644,
	"./emblems/Iseltwald-coat_of_arms.svg": 1645,
	"./emblems/Isenthal-coat_of_arms.svg": 1646,
	"./emblems/Iserables-coat_of_arms.svg": 1647,
	"./emblems/Isone-coat_of_arms.svg": 1648,
	"./emblems/Ittigen-coat_of_arms.svg": 1649,
	"./emblems/Jaberg-coat_of_arms.svg": 1650,
	"./emblems/Jaun-coat_of_arms.svg": 1651,
	"./emblems/Jegenstorf-coat_of_arms.svg": 1652,
	"./emblems/Jenaz_wappen.svg": 1653,
	"./emblems/Jenins_wappen.svg": 1654,
	"./emblems/Jens-coat_of_arms.svg": 1655,
	"./emblems/Jongny-coat_of_arms.svg": 1656,
	"./emblems/Jorat-Menthue-coat_of_arms.svg": 1657,
	"./emblems/Jorat-Mezieres_Wappen.svg": 1658,
	"./emblems/Jouxtens-Mezery-coat_of_arms.svg": 1659,
	"./emblems/Juriens-coat_of_arms.svg": 1660,
	"./emblems/Jussy-coat_of_arms.svg": 1661,
	"./emblems/Kallnach-coat_of_arms.svg": 1662,
	"./emblems/Kammersrohr-blason.svg": 1663,
	"./emblems/Kandergrund-coat_of_arms.svg": 1664,
	"./emblems/Kandersteg-coat_of_arms.svg": 1665,
	"./emblems/Kappel-blason.png": 1666,
	"./emblems/Kappel_am_Albis-blazon.svg": 1667,
	"./emblems/Kappelen-coat_of_arms.svg": 1668,
	"./emblems/Kaufdorf-coat_of_arms.svg": 1669,
	"./emblems/Kehrsatz-coat_of_arms.svg": 1670,
	"./emblems/Kernenried-coat_of_arms.svg": 1671,
	"./emblems/Kerns-coat_of_arms.svg": 1672,
	"./emblems/Kerzers-coat_of_arms.svg": 1673,
	"./emblems/Kestenholz-blason.png": 1674,
	"./emblems/Kiesen-coat_of_arms.svg": 1675,
	"./emblems/Kilchberg-blazon.svg": 1676,
	"./emblems/Kippel-coat_of_arms.svg": 1677,
	"./emblems/Kirchberg-coat_of_arms.svg": 1678,
	"./emblems/Kirchdorf-coat_of_arms.svg": 1679,
	"./emblems/Kirchlindach-coat_of_arms.svg": 1680,
	"./emblems/Kleinandelfingen-blazon.svg": 1681,
	"./emblems/Kleinboesingen-coat_of_arms.svg": 1682,
	"./emblems/Kleinluetzel-blason.png": 1683,
	"./emblems/Klosters-Serneus_wappen.svg": 1684,
	"./emblems/Kloten-blazon.svg": 1685,
	"./emblems/Knonau-blazon.svg": 1686,
	"./emblems/Knutwil_LU.png": 1687,
	"./emblems/Konolfingen_(district)-coat_of_arms.svg": 1688,
	"./emblems/Koppigen-coat_of_arms.svg": 1689,
	"./emblems/Krattigen-coat_of_arms.svg": 1690,
	"./emblems/Krauchthal-coat_of_arms.svg": 1691,
	"./emblems/Kreuzlin.GIF": 4057,
	"./emblems/Kriechenwil-coat_of_arms.svg": 1692,
	"./emblems/Kriegstetten-blason.png": 1693,
	"./emblems/Kriens_LU.png": 1694,
	"./emblems/Kueblis_wappen.svg": 1695,
	"./emblems/Kuesnacht-blazon.svg": 1696,
	"./emblems/L-Abergement-blazono.png": 1697,
	"./emblems/L_Abbaye-coat_of_arms.svg": 1698,
	"./emblems/L_Isle-coat_of_arms.svg": 1699,
	"./emblems/LaGrandeBeroche-blazon.svg": 1700,
	"./emblems/La_Baroche-coat_of_arms.svg": 1701,
	"./emblems/La_Brevine-coat_of_arms.svg": 1702,
	"./emblems/La_Brillaz-coat_of_arms.svg": 1703,
	"./emblems/La_Chaux-coat_of_arms.svg": 1704,
	"./emblems/La_Chaux-de-Fonds-coat_of_arms.svg": 1705,
	"./emblems/La_Chaux-du-Milieu-coat_of_arms.svg": 1706,
	"./emblems/La_Ferriere-coat_of_arms.svg": 1707,
	"./emblems/La_Neuveville-coat_of_arms.svg": 1708,
	"./emblems/La_Praz-coat_of_arms.svg": 1709,
	"./emblems/La_Punt-Chamues-ch_wappen.svg": 1710,
	"./emblems/La_Rippe-coat_of_arms.svg": 1711,
	"./emblems/La_Roche-coat_of_arms.svg": 1712,
	"./emblems/La_Sagne-coat_of_arms.svg": 1713,
	"./emblems/La_Sarraz-coat_of_arms.svg": 1714,
	"./emblems/La_Sonnaz-coat_of_arms.svg": 1715,
	"./emblems/La_Tour-de-Peilz-coat_of_arms.svg": 1716,
	"./emblems/La_Verrerie-coat_of_arms.svg": 1717,
	"./emblems/Laax_wappen.svg": 1718,
	"./emblems/Laconnex-coat_of_arms.svg": 1719,
	"./emblems/Lajoux.png": 1720,
	"./emblems/Lalden-coat_of_arms.svg": 1721,
	"./emblems/Lamone-coat_of_arms.svg": 1722,
	"./emblems/Lancy-coat_of_arms.svg": 1723,
	"./emblems/Landiswil-coat_of_arms.svg": 1724,
	"./emblems/Landquart-coat_of_arms.svg": 1725,
	"./emblems/Langendorf-blason.png": 1726,
	"./emblems/Langenthal-coat_of_arms.svg": 1727,
	"./emblems/Langnau_am_Albis.svg": 1728,
	"./emblems/Langnau_im_Emmental-coat_of_arms.svg": 1729,
	"./emblems/Langrickenbach.GIF": 4058,
	"./emblems/Lantsch_Lenz_wappen.svg": 1730,
	"./emblems/Lauenen-coat_of_arms.svg": 1731,
	"./emblems/Laufen-Uhwiesen-blazon.svg": 1732,
	"./emblems/Laupen-coat_of_arms.svg": 1733,
	"./emblems/Laupersdorf-blason.png": 1734,
	"./emblems/Lauperswil-coat_of_arms.svg": 1735,
	"./emblems/Lauterbrunnen-coat_of_arms.svg": 1736,
	"./emblems/Lavertezzo-coat_of_arms.svg": 1737,
	"./emblems/Lavigny-coat_of_arms.svg": 1738,
	"./emblems/Lavizzara-coat_of_arms.svg": 1739,
	"./emblems/Lax.png": 1740,
	"./emblems/Le_Bemont_Blazono.png": 1741,
	"./emblems/Le_Cerneux-Pequignot-coat_of_arms.svg": 1742,
	"./emblems/Le_Chatelard_FR-coat_of_arms.svg": 1743,
	"./emblems/Le_Flon-coat_of_arms.svg": 1744,
	"./emblems/Le_Landeron_Wappen.png": 1745,
	"./emblems/Le_Lieu.png": 1746,
	"./emblems/Le_Locle-coat_of_arms.svg": 1747,
	"./emblems/Le_Mont-sur-Lausanne-coat_of_arms.svg": 1748,
	"./emblems/Le_Noirmont.png": 1749,
	"./emblems/Le_Paquier_FR-coat_of_arms.svg": 1750,
	"./emblems/Le_Vaud-coat_of_arms.svg": 1751,
	"./emblems/Leissigen-coat_of_arms.svg": 1752,
	"./emblems/Lengnau_bei_Biel-coat_of_arms.svg": 1753,
	"./emblems/Lengwil-blazon.svg": 1754,
	"./emblems/Lenk_im_Simmental-coat_of_arms.svg": 1755,
	"./emblems/Lens_(Switzerland)-coat_of_arms.svg": 1756,
	"./emblems/Les_Breuleux-coat_of_arms.svg": 1757,
	"./emblems/Les_Clees-coat_of_arms.svg": 1758,
	"./emblems/Les_Cullayes-coat_of_arms.svg": 1759,
	"./emblems/Les_Genevez_Blazono.png": 1760,
	"./emblems/Les_Planchettes-coat_of_arms.svg": 1761,
	"./emblems/Les_Verrieres-coat_of_arms.svg": 1762,
	"./emblems/Lesboisblason.png": 1763,
	"./emblems/Leuk_VS.gif": 4059,
	"./emblems/Leuzigen-coat_of_arms.svg": 1764,
	"./emblems/Leytron-coat_of_arms.svg": 1765,
	"./emblems/Liddes_blazono.png": 1766,
	"./emblems/Ligerz-coat_of_arms.svg": 1767,
	"./emblems/Lignerolle-coat_of_arms.svg": 1768,
	"./emblems/Lignieres-coat_of_arms.svg": 1769,
	"./emblems/Lindau-blazon.svg": 1770,
	"./emblems/Linden-coat_of_arms.svg": 1771,
	"./emblems/Linescio-coat_of_arms.svg": 1772,
	"./emblems/Locarno-coat_of_arms.svg": 1773,
	"./emblems/Logo_Le_Chenit.png": 1774,
	"./emblems/Logoicogne.png": 1775,
	"./emblems/Lohn-Ammannsegg-blason.png": 1776,
	"./emblems/Lommis-Blazono.png": 1777,
	"./emblems/Lommiswil-blason.png": 1778,
	"./emblems/Lonay-coat_of_arms.svg": 1779,
	"./emblems/Longirod-coat_of_arms.svg": 1780,
	"./emblems/Losone-coat_of_arms.svg": 1781,
	"./emblems/Lostallo_wappen.svg": 1782,
	"./emblems/Lostorf-blason.png": 1783,
	"./emblems/Lotzwil-coat_of_arms.svg": 1784,
	"./emblems/Lovatens.png": 1785,
	"./emblems/Loveresse-coat_of_arms.svg": 1786,
	"./emblems/Luescherz-coat_of_arms.svg": 1787,
	"./emblems/Lueterkofen-blason.png": 1788,
	"./emblems/Luetschental-coat_of_arms.svg": 1789,
	"./emblems/Luetzelflueh-coat_of_arms.svg": 1790,
	"./emblems/Lufingen-blazon.svg": 1791,
	"./emblems/Lugano-coat_of_arms.svg": 1792,
	"./emblems/Luins-coat_of_arms.svg": 1793,
	"./emblems/Lully-coat_of_arms.svg": 1794,
	"./emblems/Lumino-coat_of_arms.svg": 1795,
	"./emblems/Lungern-coat_of_arms.svg": 1796,
	"./emblems/Lussery-Villars-coat_of_arms.svg": 1797,
	"./emblems/Lussy-sur-Morges-coat_of_arms.svg": 1798,
	"./emblems/Luterbach-blason.png": 1799,
	"./emblems/Luthern_LU.png": 1800,
	"./emblems/Lutry-coat_of_arms.svg": 1801,
	"./emblems/Lutzenbe.png": 1802,
	"./emblems/Luzein_wappen.svg": 1803,
	"./emblems/Lyss-coat_of_arms.svg": 1804,
	"./emblems/Lyssach-coat_of_arms.svg": 1805,
	"./emblems/Madiswil-coat_of_arms.svg": 1806,
	"./emblems/Madulain_wappen.svg": 1807,
	"./emblems/Maennedorf-blazon.svg": 1808,
	"./emblems/Magden-blason.png": 1809,
	"./emblems/Maggia-coat_of_arms.svg": 1810,
	"./emblems/Magliaso-coat_of_arms.svg": 1811,
	"./emblems/Maienfeld_wappen.svg": 1812,
	"./emblems/Malans_wappen.svg": 1813,
	"./emblems/Malters_LU.png": 1814,
	"./emblems/Mammern-Blazono.png": 1815,
	"./emblems/Mandach-blason.png": 1816,
	"./emblems/Manno-coat_of_arms.svg": 1817,
	"./emblems/Maracon-coat_of_arms.svg": 1818,
	"./emblems/Marbach_Wappen_2.png": 1819,
	"./emblems/Marchissy-coat_of_arms.svg": 1820,
	"./emblems/Marly-coat_of_arms.svg": 1821,
	"./emblems/Marsens-coat_of_arms.svg": 1822,
	"./emblems/Marthalen-blazon.svg": 1823,
	"./emblems/Martigny-Combe_flago.png": 1824,
	"./emblems/Maschwanden-blazon.svg": 1825,
	"./emblems/Masein_wappen.svg": 1826,
	"./emblems/Massagno-coat_of_arms.svg": 1827,
	"./emblems/Massongex-coat_of_arms.svg": 1828,
	"./emblems/Massonnens-coat_of_arms.svg": 1829,
	"./emblems/Mathod-coat_of_arms.svg": 1830,
	"./emblems/Matran-coat_of_arms.svg": 1831,
	"./emblems/Matten_bei_Interlaken-coat_of_arms.svg": 1832,
	"./emblems/Mattstetten-coat_of_arms.svg": 1833,
	"./emblems/Matzendorf-blason.png": 1834,
	"./emblems/Matzingen-coat_of_arms.svg": 1835,
	"./emblems/Mauborget-coat_of_arms.svg": 1836,
	"./emblems/Mauensee_LU.png": 1837,
	"./emblems/Maur-blazon.svg": 1838,
	"./emblems/Mauraz-coat_of_arms.svg": 1839,
	"./emblems/Medel_Lucmagn_wappen.svg": 1840,
	"./emblems/Meggen_LU.png": 1841,
	"./emblems/Meienried-coat_of_arms.svg": 1842,
	"./emblems/Meierskappel_LU.png": 1843,
	"./emblems/Meikirch-coat_of_arms.svg": 1844,
	"./emblems/Meilen-blazon.svg": 1845,
	"./emblems/Meinier-coat_of_arms.svg": 1846,
	"./emblems/Meinisberg-coat_of_arms.svg": 1847,
	"./emblems/Melchnau-coat_of_arms.svg": 1848,
	"./emblems/Melide-coat_of_arms.svg": 1849,
	"./emblems/Mellikon-blason.png": 1850,
	"./emblems/Mels-coat_of_arms.svg": 1851,
	"./emblems/Meltingen-blason.png": 1852,
	"./emblems/Mendrisio-coat_of_arms.svg": 1853,
	"./emblems/Menzingen-coat_of_arms.svg": 1854,
	"./emblems/Menznau_LU.png": 1855,
	"./emblems/Merenschwand-blason.png": 1856,
	"./emblems/Mergoscia-coat_of_arms.svg": 1857,
	"./emblems/Mervelier-Blazono.png": 1858,
	"./emblems/Merzligen-coat_of_arms.svg": 1859,
	"./emblems/Mesocco_wappen.svg": 1860,
	"./emblems/Messen-blason.png": 1861,
	"./emblems/Mettauertal_Wappen.png": 1862,
	"./emblems/Mettembert.png": 1863,
	"./emblems/Mettmenstetten-blazon.svg": 1864,
	"./emblems/Meyriez-coat_of_arms.svg": 1865,
	"./emblems/Meyrin-coat_of_arms.svg": 1866,
	"./emblems/Mezieres_FR-2004-coat_of_arms.svg": 1867,
	"./emblems/MezzovicoVira-coat_of_arms.svg": 1868,
	"./emblems/Mies-coat_of_arms.svg": 1869,
	"./emblems/Milvignes-blazon.svg": 1870,
	"./emblems/Minusio-coat_of_arms.svg": 1871,
	"./emblems/Mirchel-coat_of_arms.svg": 1872,
	"./emblems/Misery-Courtion-coat_of_arms.svg": 1873,
	"./emblems/Missy-coat_of_arms.svg": 1874,
	"./emblems/Moehlin-blason.png": 1875,
	"./emblems/Moenchaltorf-blazon.svg": 1876,
	"./emblems/Moerigen-coat_of_arms.svg": 1877,
	"./emblems/Moeriken-Wildegg-blason.png": 1878,
	"./emblems/Moerschwil_blazono.png": 1879,
	"./emblems/Moiry-coat_of_arms.svg": 1880,
	"./emblems/Mollens-coat_of_arms.svg": 1881,
	"./emblems/Molondin-coat_of_arms.svg": 1882,
	"./emblems/Mont-la-Ville-coat_of_arms.svg": 1883,
	"./emblems/Mont-sur-Rolle-coat_of_arms.svg": 1884,
	"./emblems/Mont_Tramelan-coat_of_arms.svg": 1885,
	"./emblems/Montagny-coat_of_arms.svg": 1886,
	"./emblems/Montagny-pres-Yverdon-coat_of_arms.svg": 1887,
	"./emblems/Montcherand-coat_of_arms.svg": 1888,
	"./emblems/Monteceneri_CoA.png": 1889,
	"./emblems/Montfaucon.png": 1890,
	"./emblems/Monthey_VS.png": 1891,
	"./emblems/Montilliez-coat_of_arms.svg": 1892,
	"./emblems/Montpreveyres-coat_of_arms.svg": 1893,
	"./emblems/Montreux-coat_of_arms.svg": 1894,
	"./emblems/Montricher-coat_of_arms.svg": 1895,
	"./emblems/Moosseedorf-coat_of_arms.svg": 1896,
	"./emblems/MorbioInferiore-coat_of_arms.svg": 1897,
	"./emblems/Morcote-coat_of_arms.svg": 1898,
	"./emblems/Morges-coat_of_arms.svg": 1899,
	"./emblems/Morlon-coat_of_arms.svg": 1900,
	"./emblems/Morrens-coat_of_arms.svg": 1901,
	"./emblems/Moudon-coat_of_arms.svg": 1902,
	"./emblems/Moutier_(district)-coat_of_arms.svg": 1903,
	"./emblems/Movelier-Blazono.png": 1904,
	"./emblems/Muehlau-blason.png": 1905,
	"./emblems/Muehleberg-coat_of_arms.svg": 1906,
	"./emblems/Muellheim-Blazono.png": 1907,
	"./emblems/Muelligen-blason.svg": 1908,
	"./emblems/Muemliswil-Ramiswil-blason.png": 1909,
	"./emblems/Muenchenbuchsee-coat_of_arms.svg": 1910,
	"./emblems/Muenchenwiler-coat_of_arms.svg": 1911,
	"./emblems/Muenchwilen-Blazono.png": 1912,
	"./emblems/Muenchwilen-blason.png": 1913,
	"./emblems/Muentschemier-coat_of_arms.svg": 1914,
	"./emblems/Muntelier-coat_of_arms.svg": 1915,
	"./emblems/Muolen-coat_of_arms.svg": 1916,
	"./emblems/Muralto-coat_of_arms.svg": 1917,
	"./emblems/Muri-blason.png": 1918,
	"./emblems/Muri_bei_Bern-coat_of_arms.svg": 1919,
	"./emblems/Muriaux-Blazono.png": 1920,
	"./emblems/Mutrux-coat_of_arms.svg": 1921,
	"./emblems/Muzzano-coat_of_arms.svg": 1922,
	"./emblems/NatersWappen.png": 1923,
	"./emblems/Nebikon_LU.png": 1924,
	"./emblems/Neerach-blazon.svg": 1925,
	"./emblems/Neftenbach-blazon.svg": 1926,
	"./emblems/Neggio-coat_of_arms.svg": 1927,
	"./emblems/Nendaz-armoiries.svg": 1928,
	"./emblems/Neuchatel_city_coat_of_arms.svg": 1929,
	"./emblems/Neuendorf-blason.png": 1930,
	"./emblems/Neuenegg-coat_of_arms.svg": 1931,
	"./emblems/Neuheim-Blazono.png": 1932,
	"./emblems/Neunforn-blazon.svg": 1933,
	"./emblems/Neyruz-coat_of_arms.svg": 1934,
	"./emblems/Nidau-coat_of_arms.svg": 1935,
	"./emblems/Niederbipp-coat_of_arms.svg": 1936,
	"./emblems/Niederbuchsiten-blason.png": 1937,
	"./emblems/Niederbuehren_blazono.png": 1938,
	"./emblems/Niederglatt-blazon.svg": 1939,
	"./emblems/Niedergoesgen-blason.png": 1940,
	"./emblems/Niederhasli-blazon-side.svg": 1941,
	"./emblems/Niederhe.png": 1942,
	"./emblems/Niederhuenigen-coat_of_arms.svg": 1943,
	"./emblems/Niederlenz-blason.svg": 1944,
	"./emblems/Niedermuhlern-coat_of_arms.svg": 1945,
	"./emblems/Niederoenz-coat_of_arms.svg": 1946,
	"./emblems/Niederried_bei_Interlaken-coat_of_arms.svg": 1947,
	"./emblems/Niederweningen-blazon.svg": 1948,
	"./emblems/Nods-coat_of_arms.svg": 1949,
	"./emblems/Novalles-coat_of_arms.svg": 1950,
	"./emblems/Novazzano-blason.svg": 1951,
	"./emblems/Nuerensdorf-blazon.svg": 1952,
	"./emblems/Nuglar-StPantaleon-blason.png": 1953,
	"./emblems/Nunningen-blason.png": 1954,
	"./emblems/Nuvilly-coat_of_arms.svg": 1955,
	"./emblems/Nyon-coat_of_arms.svg": 1956,
	"./emblems/Oberaegeri_Wappen.svg": 1957,
	"./emblems/Oberbalm-coat_of_arms.svg": 1958,
	"./emblems/Oberbipp-coat_of_arms.svg": 1959,
	"./emblems/Oberbuchsiten-blason.png": 1960,
	"./emblems/Oberbueren_blazono.png": 1961,
	"./emblems/Oberburg-coat_of_arms.svg": 1962,
	"./emblems/Oberdiessbach-coat_of_arms.svg": 1963,
	"./emblems/Oberdorf-blason.png": 1964,
	"./emblems/Oberdorf-coat_of_arms.svg": 1965,
	"./emblems/Oberegg-Wappen.png": 1966,
	"./emblems/Oberembrach-blazon.svg": 1967,
	"./emblems/Oberengstringen-blazon.svg": 1968,
	"./emblems/Obergerlafingen-blason.png": 1969,
	"./emblems/Oberglatt-blazon.svg": 1970,
	"./emblems/Obergoesgen-blason.png": 1971,
	"./emblems/Obergoms_(1).png": 1972,
	"./emblems/Oberhasli-coat_of_arms.svg": 1973,
	"./emblems/Oberhof-blason.png": 1974,
	"./emblems/Oberhofen_am_Thunersee-coat_of_arms.svg": 1975,
	"./emblems/Oberhuenigen-coat_of_arms.svg": 1976,
	"./emblems/Oberkirch_LU.png": 1977,
	"./emblems/Oberlangenegg-coat_of_arms.svg": 1978,
	"./emblems/Obermumpf-blason.png": 1979,
	"./emblems/Oberried_am_Brienzersee-coat_of_arms.svg": 1980,
	"./emblems/Oberrieden.svg": 1981,
	"./emblems/Oberrueti-blason.png": 1982,
	"./emblems/Obersaxen_wappen.svg": 1983,
	"./emblems/Obersimmental-coat_of_arms.svg": 1984,
	"./emblems/Oberthal-coat_of_arms.svg": 1985,
	"./emblems/Oberuzwil-coat_of_arms.svg": 1986,
	"./emblems/Oberweningen-blazon.svg": 1987,
	"./emblems/Oberwil_b_bueren.gif": 4060,
	"./emblems/Oberwil_im_Simmental-coat_of_arms.svg": 1988,
	"./emblems/Obfelden-blazon.svg": 1989,
	"./emblems/Ochlenberg-coat_of_arms.svg": 1990,
	"./emblems/Oensingen-blason.png": 1991,
	"./emblems/Oeschenbach-coat_of_arms.svg": 1992,
	"./emblems/Oetwil_am_See-blazon.svg": 1993,
	"./emblems/Oetwil_an_der_Limmat.svg": 1994,
	"./emblems/Offizielles_Wappen_von_Stein_am_Rhein.png": 1995,
	"./emblems/Ogens-coat_of_arms.svg": 1996,
	"./emblems/Ollon-coat_of_arms.svg": 1997,
	"./emblems/Olten-blason.png": 1998,
	"./emblems/Onex-coat_of_arms.svg": 1999,
	"./emblems/Onnens-coat_of_arms.svg": 2000,
	"./emblems/Onsernone-coat_of_arms.svg": 2001,
	"./emblems/Opfikon-blazon.svg": 2002,
	"./emblems/Oppens-coat_of_arms.svg": 2003,
	"./emblems/Oppligen-coat_of_arms.svg": 2004,
	"./emblems/Orges-coat_of_arms.svg": 2005,
	"./emblems/Origlio-coat_of_arms.svg": 2006,
	"./emblems/Orny-coat_of_arms.svg": 2007,
	"./emblems/Oron-coat_of_arms.svg": 2008,
	"./emblems/Orpund-coat_of_arms.svg": 2009,
	"./emblems/Orselina-coat_of_arms.svg": 2010,
	"./emblems/Orsieres.png": 2011,
	"./emblems/Orvin-coat_of_arms.svg": 2012,
	"./emblems/Orzens-coat_of_arms.svg": 2013,
	"./emblems/Ossingen-blazon.svg": 2014,
	"./emblems/Ostermundigen-coat_of_arms.svg": 2015,
	"./emblems/Otelfingen-blazon.svg": 2016,
	"./emblems/Othmarsingen-blason.png": 2017,
	"./emblems/Ottenbach-blazon.svg": 2018,
	"./emblems/Oulens-sous-Echallens-coat_of_arms.svg": 2019,
	"./emblems/Pailly-coat_of_arms.svg": 2020,
	"./emblems/Paradiso-coat_of_arms.svg": 2021,
	"./emblems/Paudex-coat_of_arms.svg": 2022,
	"./emblems/Payerne-coat_of_arms.svg": 2023,
	"./emblems/Penthalaz-coat_of_arms.svg": 2024,
	"./emblems/Penthaz-coat_of_arms.svg": 2025,
	"./emblems/Penthereaz-coat_of_arms.svg": 2026,
	"./emblems/PerlyCertoux-coat_of_arms.svg": 2027,
	"./emblems/Perrefitte-coat_of_arms.svg": 2028,
	"./emblems/Perroy-coat_of_arms.svg": 2029,
	"./emblems/Personico-coat_of_arms.svg": 2030,
	"./emblems/Pery-La_Heutte-coat_of_arms.svg": 2031,
	"./emblems/Pfaeffikon-blazon.svg": 2032,
	"./emblems/Pfaffnau_LU.png": 2033,
	"./emblems/Pfungen-blazon.svg": 2034,
	"./emblems/Pfyn.gif": 4061,
	"./emblems/Pic_Neuenkirch.png": 2035,
	"./emblems/Pierrafortscha-coat_of_arms.svg": 2036,
	"./emblems/Pieterlen-coat_of_arms.svg": 2037,
	"./emblems/Plaffeien-coat_of_arms.svg": 2038,
	"./emblems/PlanLesOuates-coat_of_arms.svg": 2039,
	"./emblems/Plasselb-coat_of_arms.svg": 2040,
	"./emblems/Pleigne-Blazono.png": 2041,
	"./emblems/Pohlern-coat_of_arms.svg": 2042,
	"./emblems/Poliez-Pittet.png": 2043,
	"./emblems/Pollegio-coat_of_arms.svg": 2044,
	"./emblems/Pompaples-coat_of_arms.svg": 2045,
	"./emblems/Pomy-coat_of_arms.svg": 2046,
	"./emblems/Pont-la-Ville-coat_of_arms.svg": 2047,
	"./emblems/PonteCapriasca-coat_of_arms.svg": 2048,
	"./emblems/Pontresina_wappen.svg": 2049,
	"./emblems/Porrentruy-blason.png": 2050,
	"./emblems/Port-Valais_Coat_of_Arms.svg": 2051,
	"./emblems/Port-coat_of_arms.svg": 2052,
	"./emblems/Porza-coat_of_arms.svg": 2053,
	"./emblems/Poschiavo_wappen.svg": 2054,
	"./emblems/Prangins-coat_of_arms.svg": 2055,
	"./emblems/Pratteln-coat_of_arms.svg": 2056,
	"./emblems/PregnyChambesy-coat_of_arms.svg": 2057,
	"./emblems/Premier-coat_of_arms.svg": 2058,
	"./emblems/Presinge-coat_of_arms.svg": 2059,
	"./emblems/Preverenges-coat_of_arms.svg": 2060,
	"./emblems/Prevondavaux-coat_of_arms.svg": 2061,
	"./emblems/Prevonloup.svg": 2062,
	"./emblems/Prilly-coat_of_arms.svg": 2063,
	"./emblems/Provence.png": 2064,
	"./emblems/Puidoux-coat_of_arms.svg": 2065,
	"./emblems/Pully-coat_of_arms.svg": 2066,
	"./emblems/Puplinge-coat_of_arms.svg": 2067,
	"./emblems/Pura-coat_of_arms.svg": 2068,
	"./emblems/Quarten.png": 2069,
	"./emblems/Quinto-coat_of_arms.svg": 2070,
	"./emblems/Radelfingen-coat_of_arms.svg": 2071,
	"./emblems/Rafz-blazon.svg": 2072,
	"./emblems/Rain_LU.png": 2073,
	"./emblems/Rances-coat_of_arms.svg": 2074,
	"./emblems/Raperswilen.gif": 4062,
	"./emblems/Rapperswil-Jona_CoA.svg": 2075,
	"./emblems/Rapperswil-coat_of_arms.svg": 2076,
	"./emblems/Realp-coat_of_arms.svg": 2077,
	"./emblems/Rebevelier-coat_of_arms.svg": 2078,
	"./emblems/Rebstein_wappen.png": 2079,
	"./emblems/Recherswil-blason.png": 2080,
	"./emblems/Rechthalten-coat_of_arms.svg": 2081,
	"./emblems/Reconvilier-coat_of_arms.svg": 2082,
	"./emblems/Regensberg-blazon.svg": 2083,
	"./emblems/Rehetobe.png": 2084,
	"./emblems/Reichenbach_2farbig_transparent.png": 2085,
	"./emblems/Reiden_LU.png": 2086,
	"./emblems/Reisiswil-coat_of_arms.svg": 2087,
	"./emblems/Remaufens-coat_of_arms.svg": 2088,
	"./emblems/Renan-coat_of_arms.svg": 2089,
	"./emblems/Reute.png": 2090,
	"./emblems/Reutigen-coat_of_arms.svg": 2091,
	"./emblems/Rhaezuens_wappen.svg": 2092,
	"./emblems/Rheinau-blazon.svg": 2093,
	"./emblems/Rheineck-coat_of_arms.svg": 2094,
	"./emblems/Riaz-coat_of_arms.svg": 2095,
	"./emblems/Richterswil.svg": 2096,
	"./emblems/Rickenbach(Turgovio)-Blazono.png": 2097,
	"./emblems/Rickenbach-blason.png": 2098,
	"./emblems/Rickenbach-blazon.svg": 2099,
	"./emblems/Rickenbach_LU.png": 2100,
	"./emblems/Riddes_wappen.png": 2101,
	"./emblems/Ried-coat_of_arms.svg": 2102,
	"./emblems/Riedbrig.png": 2103,
	"./emblems/Riedholz-blason.png": 2104,
	"./emblems/Riehen-coat_of_arms.svg": 2105,
	"./emblems/Riex-coat_of_arms.svg": 2106,
	"./emblems/Rifferswil.svg": 2107,
	"./emblems/Riggisberg-coat_of_arms.svg": 2108,
	"./emblems/Ringgenberg-coat_of_arms.svg": 2109,
	"./emblems/RivaSanVitale-coat_of_arms.svg": 2110,
	"./emblems/Rivaz-coat_of_arms.svg": 2111,
	"./emblems/Riviera-coat_of_arms.svg": 2112,
	"./emblems/Roche_(Vaud)-coat_of_arms.svg": 2113,
	"./emblems/Rochefort-NE-blason.png": 2114,
	"./emblems/Roches-coat_of_arms.svg": 2115,
	"./emblems/Rodersdorf-blason.png": 2116,
	"./emblems/Roemerswil_LU.png": 2117,
	"./emblems/Roethenbach_im_Emmental-coat_of_arms.svg": 2118,
	"./emblems/Roggliswil_LU.png": 2119,
	"./emblems/Roggwil-coat_of_arms.svg": 2120,
	"./emblems/Roggwil_TG-coat_of_arms.svg": 2121,
	"./emblems/Rohrbach-coat_of_arms.svg": 2122,
	"./emblems/Rohrbachgraben-coat_of_arms.svg": 2123,
	"./emblems/Rolle_district_coa.png": 2124,
	"./emblems/Romanel-sur-Lausanne-coat_of_arms.svg": 2125,
	"./emblems/Romanel-sur-Morges-coat_of_arms.svg": 2126,
	"./emblems/Romont_(Fribourg)-coat_of_arms.svg": 2127,
	"./emblems/Romont_BE-coat_of_arms.svg": 2128,
	"./emblems/Romoos_LU.png": 2129,
	"./emblems/RoncoSopraAscona-coat_of_arms.svg": 2130,
	"./emblems/Rongellen_wappen.svg": 2131,
	"./emblems/Root_LU.png": 2132,
	"./emblems/Ropraz.png": 2133,
	"./emblems/Rorbas-blazon.svg": 2134,
	"./emblems/Rorschab.png": 2135,
	"./emblems/Rorschach.sg.png": 2136,
	"./emblems/Rossa_wappen.svg": 2137,
	"./emblems/Rossemaison.png": 2138,
	"./emblems/Rossiniere-coat_of_arms.svg": 2139,
	"./emblems/Rothenbrunnen_wappen.svg": 2140,
	"./emblems/Rothenburg_LU.png": 2141,
	"./emblems/Rottenschwil-blason.png": 2142,
	"./emblems/Rougemont-coat_of_arms.svg": 2143,
	"./emblems/Roveredo_wappen.svg": 2144,
	"./emblems/Rovray-coat_of_arms.svg": 2145,
	"./emblems/Rubigen-coat_of_arms.svg": 2146,
	"./emblems/Rudolfstetten-blason.png": 2147,
	"./emblems/Rue-coat_of_arms.svg": 2148,
	"./emblems/Ruederswil-coat_of_arms.svg": 2149,
	"./emblems/Ruedtligen-Alchenflueh-coat_of_arms.svg": 2150,
	"./emblems/Rueeggisberg-coat_of_arms.svg": 2151,
	"./emblems/Rueegsau-coat_of_arms.svg": 2152,
	"./emblems/Ruemlang-blazon.svg": 2153,
	"./emblems/Rueschegg-coat_of_arms.svg": 2154,
	"./emblems/Rueschlikon-blazon.svg": 2155,
	"./emblems/Rueti-blazon.svg": 2156,
	"./emblems/Rueti_bei_Bueren-coat_of_arms.svg": 2157,
	"./emblems/Rueti_bei_Lyssach-coat_of_arms.svg": 2158,
	"./emblems/Ruetschelen-coat_of_arms.svg": 2159,
	"./emblems/Ruettenen-blason.png": 2160,
	"./emblems/Rueyres-coat_of_arms.svg": 2161,
	"./emblems/Rumendingen-coat_of_arms.svg": 2162,
	"./emblems/Rumisberg-coat_of_arms.svg": 2163,
	"./emblems/Russikon-blazon.svg": 2164,
	"./emblems/Russin-coat_of_arms.svg": 2165,
	"./emblems/Ruswil_LU.png": 2166,
	"./emblems/Ruth_Wappeni.png": 2167,
	"./emblems/S-chanf_wappen.svg": 2168,
	"./emblems/Saanen-coat_of_arms.svg": 2169,
	"./emblems/Saas-Fee-coat_of_arms.svg": 2170,
	"./emblems/Saas_Balen_Wappen.png": 2171,
	"./emblems/Saas_Grund_Wappen.png": 2172,
	"./emblems/Sachseln-coat_of_arms.svg": 2173,
	"./emblems/Safiental.svg": 2174,
	"./emblems/Safnern-coat_of_arms.svg": 2175,
	"./emblems/Sagogn_wappen.svg": 2176,
	"./emblems/Saicourt-coat_of_arms.svg": 2177,
	"./emblems/Saignelegier-armoiries.svg": 2178,
	"./emblems/Saint-Aubin-coat_of_arms.svg": 2179,
	"./emblems/Saint-Barthelemy-coat_of_arms.svg": 2180,
	"./emblems/Saint-Brais-Blazono.png": 2181,
	"./emblems/Saint-Cergue-coat_of_arms.svg": 2182,
	"./emblems/Saint-George-coat_of_arms.svg": 2183,
	"./emblems/Saint-Gingolph_Wappen.svg": 2184,
	"./emblems/Saint-Livres-coat_of_arms.svg": 2185,
	"./emblems/Saint-Martin_VS.png": 2186,
	"./emblems/Saint-Oyens-coat_of_arms.svg": 2187,
	"./emblems/Saint-Prex-coat_of_arms.svg": 2188,
	"./emblems/Saint-Saphorin-coat_of_arms.svg": 2189,
	"./emblems/Saint-Sulpice-coat_of_arms.svg": 2190,
	"./emblems/Saint_Imier-coat_of_arms.svg": 2191,
	"./emblems/Sainte-Croix-coat_of_arms.svg": 2192,
	"./emblems/Sales_Blason.png": 2193,
	"./emblems/Salmsach-Blazono.png": 2194,
	"./emblems/Salvan.png": 2195,
	"./emblems/Samedan_wappen.svg": 2196,
	"./emblems/Samnaun-coa.png": 2197,
	"./emblems/San_Vittore_wappen.svg": 2198,
	"./emblems/Sankt-Margreto-Blazono.png": 2199,
	"./emblems/Sankt_Stephan-coat_of_arms.svg": 2200,
	"./emblems/SantAntonino-coat_of_arms.svg": 2201,
	"./emblems/Sargans-coat_of_arms.svg": 2202,
	"./emblems/Sarnen-coat_of_arms.svg": 2203,
	"./emblems/Satigny-coat_of_arms.svg": 2204,
	"./emblems/Saubraz-coat_of_arms.svg": 2205,
	"./emblems/Sauge-coat_of_arms.svg": 2206,
	"./emblems/Saulcy_Blazono.png": 2207,
	"./emblems/Saules-coat_of_arms.svg": 2208,
	"./emblems/Saviese-coat_of_arms.svg": 2209,
	"./emblems/Savigny-coat_of_arms.svg": 2210,
	"./emblems/Savosa-coat_of_arms.svg": 2211,
	"./emblems/Saxeten-coat_of_arms.svg": 2212,
	"./emblems/Schafisheim-blason.png": 2213,
	"./emblems/Schangnau-coat_of_arms.svg": 2214,
	"./emblems/Scharans_wappen.svg": 2215,
	"./emblems/Schattenhalb-coat_of_arms.svg": 2216,
	"./emblems/Schelten-coat_of_arms.svg": 2217,
	"./emblems/Scheuren-coat_of_arms.svg": 2218,
	"./emblems/Schiers_wappen.svg": 2219,
	"./emblems/Schinznach_Wappen.png": 2220,
	"./emblems/Schlatt-Haslen-Wappen.png": 2221,
	"./emblems/Schlatt-blazon.svg": 2222,
	"./emblems/Schleinikon-blazon.svg": 2223,
	"./emblems/Schlierbach_LU.png": 2224,
	"./emblems/Schlieren-blazon.svg": 2225,
	"./emblems/Schlossrued-blason.png": 2226,
	"./emblems/Schluein_wappen.svg": 2227,
	"./emblems/Schmiedrued-blason.png": 2228,
	"./emblems/Schmitten-FR--coat_of_arms.svg": 2229,
	"./emblems/Schmitten_GR_wappen.svg": 2230,
	"./emblems/Schnottwil-blason.png": 2231,
	"./emblems/Schoefflisdorf-blazon.svg": 2232,
	"./emblems/Schoenenwerd_wappen.svg": 2233,
	"./emblems/Schoetz_LU.png": 2234,
	"./emblems/Schoneng.png": 2235,
	"./emblems/Schongau_LU.png": 2236,
	"./emblems/Schuepfen-coat_of_arms.svg": 2237,
	"./emblems/Schuepfheim_LU.png": 2238,
	"./emblems/Schupfart-blason.svg": 2239,
	"./emblems/Schwadernau-coat_of_arms.svg": 2240,
	"./emblems/Schwanden_bei_Brienz-coat_of_arms.svg": 2241,
	"./emblems/Schwarzenberg_LU.png": 2242,
	"./emblems/Schwarzenburg-coat_of_arms.svg": 2243,
	"./emblems/Schwarzhaeusern-coat_of_arms.svg": 2244,
	"./emblems/Schwellb.png": 2245,
	"./emblems/Schwerzenbach-blazon.svg": 2246,
	"./emblems/Scuol_wappen.svg": 2247,
	"./emblems/Seeberg-coat_of_arms.svg": 2248,
	"./emblems/Seedorf_BE-coat_of_arms.svg": 2249,
	"./emblems/Seegraeben-blazon.svg": 2250,
	"./emblems/Seehof-coat_of_arms.svg": 2251,
	"./emblems/Seengen-blason.png": 2252,
	"./emblems/Seewen-blason.png": 2253,
	"./emblems/Seewis_wappen.svg": 2254,
	"./emblems/Seftigen-coat_of_arms.svg": 2255,
	"./emblems/Selzach-blason.png": 2256,
	"./emblems/Sembrancher.png": 2257,
	"./emblems/Sempach_LU.png": 2258,
	"./emblems/Semsales-coat_of_arms.svg": 2259,
	"./emblems/Senarclens-coat_of_arms.svg": 2260,
	"./emblems/Sennwald-coat_of_arms.svg": 2261,
	"./emblems/Seon-blason.png": 2262,
	"./emblems/Sergey.png": 2263,
	"./emblems/Serravalle_stemma.png": 2264,
	"./emblems/Seuzach-blazon.svg": 2265,
	"./emblems/Sevaz-coat_of_arms.svg": 2266,
	"./emblems/Sevelen-coat_of_arms.svg": 2267,
	"./emblems/Siglistorf-blason.png": 2268,
	"./emblems/Signau-coat_of_arms.svg": 2269,
	"./emblems/Signy-Avenex-coat_of_arms.svg": 2270,
	"./emblems/Sigriswil-coat_of_arms.svg": 2271,
	"./emblems/Sils_i_D_wappen.svg": 2272,
	"./emblems/Sils_i_E_Segl_wappen.svg": 2273,
	"./emblems/Silvaplana_wappen.svg": 2274,
	"./emblems/Sins-blason.png": 2275,
	"./emblems/Sion-coat_of_arms.svg": 2276,
	"./emblems/Sirnach-Blazono.png": 2277,
	"./emblems/Siselen-coat_of_arms.svg": 2278,
	"./emblems/Sisikon-coat_of_arms.svg": 2279,
	"./emblems/Sisseln-blason.png": 2280,
	"./emblems/Snake-coat_of_arms.svg": 2281,
	"./emblems/Soazza_wappen.svg": 2282,
	"./emblems/Sommeri-Blazono.png": 2283,
	"./emblems/Sonceboz_Sombeval-coat_of_arms.svg": 2284,
	"./emblems/Sonvilier-coat_of_arms.svg": 2285,
	"./emblems/Soral-coat_of_arms.svg": 2286,
	"./emblems/Sorengo-coat_of_arms.svg": 2287,
	"./emblems/Sorens-coat_of_arms.svg": 2288,
	"./emblems/Sorvilier-coat_of_arms.svg": 2289,
	"./emblems/Soubey.png": 2290,
	"./emblems/Soyhieres-Blazono.png": 2291,
	"./emblems/Speicherar.png": 2292,
	"./emblems/Spiez-coat_of_arms.svg": 2293,
	"./emblems/Spiringen-Wappen.svg": 2294,
	"./emblems/St._Silvester-coat_of_arms.svg": 2295,
	"./emblems/St._Ursen-coat_of_arms.svg": 2296,
	"./emblems/St_Moritz_wappen.svg": 2297,
	"./emblems/St_Niklaus_Wappen.png": 2298,
	"./emblems/Sta_Maria_in_Calanca_wappen.svg": 2299,
	"./emblems/Stabio-coat_of_arms.svg": 2300,
	"./emblems/Stadel-blazon.svg": 2301,
	"./emblems/Staefa-blazon.svg": 2302,
	"./emblems/Staldenried_Wappen.png": 2303,
	"./emblems/Stallikon-blazon.svg": 2304,
	"./emblems/Stans-coat_of_arms.svg": 2305,
	"./emblems/Stansstad-coat_of_arms.svg": 2306,
	"./emblems/Starrkirch-Wil-blason.png": 2307,
	"./emblems/Staufen_blason.svg": 2308,
	"./emblems/Steffisburg-coat_of_arms.svg": 2309,
	"./emblems/Steg-Hohtenn-Coat_of_Arms.png": 2310,
	"./emblems/Stein-blason.png": 2311,
	"./emblems/Steinach.png": 2312,
	"./emblems/Steinar.png": 2313,
	"./emblems/Steinhausen_Wappen.svg": 2314,
	"./emblems/Steinmaur-blazon.svg": 2315,
	"./emblems/Stemma_Terre_di_Pedemonte.png": 2316,
	"./emblems/Stettfurt-Blazono.png": 2317,
	"./emblems/Stettlen-coat_of_arms.svg": 2318,
	"./emblems/Stleonard.blason.png": 2319,
	"./emblems/Stocken-Hoefen-coat_of_arms.svg": 2320,
	"./emblems/Studen-coat_of_arms.svg": 2321,
	"./emblems/Stuesslingen-blason.png": 2322,
	"./emblems/Subingen-blason.png": 2323,
	"./emblems/Suchy-coat_of_arms.svg": 2324,
	"./emblems/Sufers_wappen.svg": 2325,
	"./emblems/Sulgen-Blazono--uff.png": 2326,
	"./emblems/Sullens-coat_of_arms.svg": 2327,
	"./emblems/Sumiswald-coat_of_arms.svg": 2328,
	"./emblems/Surpierre-coat_of_arms.svg": 2329,
	"./emblems/Sursee_LU.png": 2330,
	"./emblems/Surses_(Kreis)_wappen.svg": 2331,
	"./emblems/Suscevaz-coat_of_arms.svg": 2332,
	"./emblems/Sutz-Lattrigen-coat_of_arms.svg": 2333,
	"./emblems/TI-Cugnasco-Gerra.png": 2334,
	"./emblems/Taegerwilen.GIF": 4063,
	"./emblems/Taesch-coat_of_arms.svg": 2335,
	"./emblems/Taeuffelen-coat_of_arms.svg": 2336,
	"./emblems/Tafers-coat_of_arms.svg": 2337,
	"./emblems/Tamins_wappen.svg": 2338,
	"./emblems/Tannay-coat_of_arms.svg": 2339,
	"./emblems/Tartegnin-coat_of_arms.svg": 2340,
	"./emblems/Tavannes-coat_of_arms.svg": 2341,
	"./emblems/Tegerfelden-blason.png": 2342,
	"./emblems/Tenero-Contra-coat_of_arms.svg": 2343,
	"./emblems/Tentlingen-coat_of_arms.svg": 2344,
	"./emblems/Termen-coat_of_arms.svg": 2345,
	"./emblems/Teuffenthal-coat_of_arms.svg": 2346,
	"./emblems/Tevenon-coat_of_arms.svg": 2347,
	"./emblems/Thal.png": 2348,
	"./emblems/Thalheim-blazon.svg": 2349,
	"./emblems/Thalwil-blazon.svg": 2350,
	"./emblems/Thayngen_Wappen.svg": 2351,
	"./emblems/Therwil-blason.svg": 2352,
	"./emblems/Thierachern-coat_of_arms.svg": 2353,
	"./emblems/Thoerigen-coat_of_arms.svg": 2354,
	"./emblems/Thonex-coat_of_arms.svg": 2355,
	"./emblems/Thumb_uc_19885_w250_Wappen_Arbaz_VS_Blason_Arbaz_VS.png": 2356,
	"./emblems/Thun-coat_of_arms.svg": 2357,
	"./emblems/Thundorf-coat_of_arms.svg": 2358,
	"./emblems/Thunstetten-coat_of_arms.svg": 2359,
	"./emblems/Thusis_wappen.svg": 2360,
	"./emblems/Toffen-coat_of_arms.svg": 2361,
	"./emblems/Tolochenaz-coat_of_arms.svg": 2362,
	"./emblems/Torny-coat_of_arms.svg": 2363,
	"./emblems/Torricella-Taverne-coat_of_arms.svg": 2364,
	"./emblems/Trachselwald-coat_of_arms.svg": 2365,
	"./emblems/Tramelan-coat_of_arms.svg": 2366,
	"./emblems/Treiten-coat_of_arms.svg": 2367,
	"./emblems/Trelex-coat_of_arms.svg": 2368,
	"./emblems/Trey-coat_of_arms.svg": 2369,
	"./emblems/Treycovagnes-coat_of_arms.svg": 2370,
	"./emblems/Treyvaux-coat_of_arms.svg": 2371,
	"./emblems/Triengen_LU.png": 2372,
	"./emblems/Trientwappen.png": 2373,
	"./emblems/Trimbach-blason.png": 2374,
	"./emblems/Trimmis_wappen.svg": 2375,
	"./emblems/Trin_wappen.svg": 2376,
	"./emblems/TrogenAR.png": 2377,
	"./emblems/Troinex-coat_of_arms.svg": 2378,
	"./emblems/Troistorrents.png": 2379,
	"./emblems/Trub-coat_of_arms.svg": 2380,
	"./emblems/Trubschachen-coat_of_arms.svg": 2381,
	"./emblems/Truellikon.svg": 2382,
	"./emblems/Trun_wappen.svg": 2383,
	"./emblems/Truttikon-blazon.svg": 2384,
	"./emblems/Tschappina_wappen.svg": 2385,
	"./emblems/Tschugg-coat_of_arms.svg": 2386,
	"./emblems/Tubach.png": 2387,
	"./emblems/Tujetsch_wappen.svg": 2388,
	"./emblems/Tumbnail.asp.png": 2389,
	"./emblems/Turbenthal.svg": 2390,
	"./emblems/Turtmann.gif": 4064,
	"./emblems/Twann-Tuescherz-coat_of_arms.svg": 2391,
	"./emblems/Udligenswil_LU.png": 2392,
	"./emblems/Ueberstorf-coat_of_arms.svg": 2393,
	"./emblems/Uebeschi-coat_of_arms.svg": 2394,
	"./emblems/Uetendorf-coat_of_arms.svg": 2395,
	"./emblems/Uetikon-blazon.svg": 2396,
	"./emblems/Ufhusen_LU.png": 2397,
	"./emblems/Uitikon-blazon.svg": 2398,
	"./emblems/Unteraegeri_Wappen.svg": 2399,
	"./emblems/Unterbaech-coat_of_arms.svg": 2400,
	"./emblems/Untereggen.sg.png": 2401,
	"./emblems/Unterengstringen-blazon.svg": 2402,
	"./emblems/Unterlangenegg-coat_of_arms.svg": 2403,
	"./emblems/Unterramsern-blason.png": 2404,
	"./emblems/Unterschaechen_UR.png": 2405,
	"./emblems/Unterseen-coat_of_arms.svg": 2406,
	"./emblems/Untervaz_wappen.svg": 2407,
	"./emblems/Urdorf-blazon.svg": 2408,
	"./emblems/Urmein_wappen.svg": 2409,
	"./emblems/Urnaesch_Wappen.png": 2410,
	"./emblems/Ursenbach-coat_of_arms.svg": 2411,
	"./emblems/Ursins-coat_of_arms.svg": 2412,
	"./emblems/Ursy-coat_of_arms.svg": 2413,
	"./emblems/Urtenen-coat_of_arms.svg": 2414,
	"./emblems/Uster-blazon.svg": 2415,
	"./emblems/Uttigen-coat_of_arms.svg": 2416,
	"./emblems/Uttwil-Blazono.png": 2417,
	"./emblems/Utzenstorf-coat_of_arms.svg": 2418,
	"./emblems/Uzwil_blazono.png": 2419,
	"./emblems/Vacallo-coat_of_arms.svg": 2420,
	"./emblems/Val-ddIlliez.png": 2421,
	"./emblems/Val-de-Charmey_Blason.png": 2422,
	"./emblems/Val_Muestair_(Kreis)_wappen.svg": 2423,
	"./emblems/Valeyres-sous-Montagny-coat_of_arms.svg": 2424,
	"./emblems/Valeyres-sous-Rances-coat_of_arms.svg": 2425,
	"./emblems/Valeyres-sous-Ursins-coat_of_arms.svg": 2426,
	"./emblems/Vallon-coat_of_arms.svg": 2427,
	"./emblems/Vallorbe-coat_of_arms.svg": 2428,
	"./emblems/Vals_wappen.svg": 2429,
	"./emblems/Valsot.gif": 4065,
	"./emblems/Vandoeuvres-coat_of_arms.svg": 2430,
	"./emblems/Varen-coat_of_arms.svg": 2431,
	"./emblems/Vaulion-coat_of_arms.svg": 2432,
	"./emblems/Vaulruz-coat_of_arms.svg": 2433,
	"./emblems/Vaux-sur-Morges-coat_of_arms.svg": 2434,
	"./emblems/Vaz_Obervaz_wappen.svg": 2435,
	"./emblems/Vechigen-coat_of_arms.svg": 2436,
	"./emblems/Vendlincourt-coat_of_arms.svg": 2437,
	"./emblems/Vernate-coat_of_arms.svg": 2438,
	"./emblems/Vernayaz.png": 2439,
	"./emblems/Vernier-coat_of_arms.svg": 2440,
	"./emblems/Versoix-coat_of_arms.svg": 2441,
	"./emblems/Vetroz.png": 2442,
	"./emblems/Vevey-coat_of_arms.svg": 2443,
	"./emblems/Vex-coat_of_arms.svg": 2444,
	"./emblems/Veyrier-coat_of_arms.svg": 2445,
	"./emblems/Veysonnaz.blason.png": 2446,
	"./emblems/Veytaux-coat_of_arms.svg": 2447,
	"./emblems/Vezia-coat_of_arms.svg": 2448,
	"./emblems/Vich-coat_of_arms.svg": 2449,
	"./emblems/VicoMorcote-coat_of_arms.svg": 2450,
	"./emblems/Villars-Epeney-coat_of_arms.svg": 2451,
	"./emblems/Villars-le-Terroir-coat_of_arms.svg": 2452,
	"./emblems/Villars-sous-Yens-coat_of_arms.svg": 2453,
	"./emblems/Villars-sur-Glane-coat_of_arms.svg": 2454,
	"./emblems/Villarsel-sur-Marly-coat_of_arms.svg": 2455,
	"./emblems/Villeret-coat_of_arms.svg": 2456,
	"./emblems/Villigen-blason.png": 2457,
	"./emblems/Villorsonnens-coat_of_arms.svg": 2458,
	"./emblems/Vilters-Wang-blazono.png": 2459,
	"./emblems/Vinelz-coat_of_arms.svg": 2460,
	"./emblems/Vinzel-coat_of_arms.svg": 2461,
	"./emblems/Vionnaz.png": 2462,
	"./emblems/Visp-Wappen.png": 2463,
	"./emblems/Visperterminen-coat_of_arms.svg": 2464,
	"./emblems/Vitznau_LU.png": 2465,
	"./emblems/Volken-blazon.svg": 2466,
	"./emblems/Volketswil-blazon.svg": 2467,
	"./emblems/Vouvry.png": 2468,
	"./emblems/Vuadens-coat_of_arms.svg": 2469,
	"./emblems/Vuarrens-coat_of_arms.svg": 2470,
	"./emblems/Vucherens_ch.png": 2471,
	"./emblems/Vufflens-le-Chateau-coat_of_arms.svg": 2472,
	"./emblems/Vuflens-la-Ville-coat_of_arms.svg": 2473,
	"./emblems/Vugelles-La_Mothe-coat_of_arms.svg": 2474,
	"./emblems/Vuiteboeuf-coat_of_arms.svg": 2475,
	"./emblems/Vulliens-coat_of_arms.svg": 2476,
	"./emblems/Vullierens-coat_of_arms.svg": 2477,
	"./emblems/Wachseldorn-coat_of_arms.svg": 2478,
	"./emblems/Waedenswil-blazon.svg": 2479,
	"./emblems/Waeldi.gif": 4066,
	"./emblems/Wagenhausen(Turgovio)-Blazono.png": 2480,
	"./emblems/Wald-blazon.svg": 2481,
	"./emblems/Wald-coat_of_arms.svg": 2482,
	"./emblems/Waldar.png": 2483,
	"./emblems/Waldkirch-blazono.png": 2484,
	"./emblems/Waldstatt-Blazono.png": 2485,
	"./emblems/Walenstadt-coat_of_arms.svg": 2486,
	"./emblems/Walkringen-coat_of_arms.svg": 2487,
	"./emblems/Wallisellen-blazon.svg": 2488,
	"./emblems/Walliswil_bei_Niederbipp-coat_of_arms.svg": 2489,
	"./emblems/Walliswil_bei_Wangen-coat_of_arms.svg": 2490,
	"./emblems/Walperswil-coat_of_arms.svg": 2491,
	"./emblems/Walterswil-blason.png": 2492,
	"./emblems/Walterswil-coat_of_arms.svg": 2493,
	"./emblems/Walzenha.png": 2494,
	"./emblems/Wangen-Bruettisellen-blazon.svg": 2495,
	"./emblems/Wangen-coat_of_arms.svg": 2496,
	"./emblems/Wangen_bO-blason.png": 2497,
	"./emblems/Wapen_Lumnezia.gif": 4067,
	"./emblems/WappenAltdorf2016.svg": 2498,
	"./emblems/WappenArbon.png": 2499,
	"./emblems/WappenSchaenisOriginal.png": 2500,
	"./emblems/Wappen_Aadorf.svg": 2501,
	"./emblems/Wappen_Aarau.svg": 2502,
	"./emblems/Wappen_Aarburg.svg": 2503,
	"./emblems/Wappen_Abtwil_AG.svg": 2504,
	"./emblems/Wappen_Aclens.svg": 2505,
	"./emblems/Wappen_Agiez.svg": 2506,
	"./emblems/Wappen_Aigle.svg": 2507,
	"./emblems/Wappen_Allaman.svg": 2508,
	"./emblems/Wappen_Allschwil.png": 2509,
	"./emblems/Wappen_Altstaetten.svg": 2510,
	"./emblems/Wappen_Ammerswil.svg": 2511,
	"./emblems/Wappen_Arisdorf.png": 2512,
	"./emblems/Wappen_Aristau.svg": 2513,
	"./emblems/Wappen_Arni_AG.svg": 2514,
	"./emblems/Wappen_Au_Kanton_St._Gallen.svg": 2515,
	"./emblems/Wappen_Augst.png": 2516,
	"./emblems/Wappen_Auw_AG.svg": 2517,
	"./emblems/Wappen_Avegno-Gordevio_2010.svg": 2518,
	"./emblems/Wappen_Bargen.png": 2519,
	"./emblems/Wappen_Basel-Stadt_matt.svg": 2520,
	"./emblems/Wappen_Beggingen.png": 2521,
	"./emblems/Wappen_Beinwil_(Freiamt).svg": 2522,
	"./emblems/Wappen_Bellikon_AG.svg": 2523,
	"./emblems/Wappen_Bergdietikon.svg": 2524,
	"./emblems/Wappen_Berikon.svg": 2525,
	"./emblems/Wappen_Beringen.png": 2526,
	"./emblems/Wappen_Bern_matt.svg": 2527,
	"./emblems/Wappen_Besenbueren.svg": 2528,
	"./emblems/Wappen_Bettwil.svg": 2529,
	"./emblems/Wappen_Biberstein.svg": 2530,
	"./emblems/Wappen_Birmenstorf.svg": 2531,
	"./emblems/Wappen_Birr_AG.svg": 2532,
	"./emblems/Wappen_Birrhard.svg": 2533,
	"./emblems/Wappen_Birrwil.svg": 2534,
	"./emblems/Wappen_Blatten_VS.svg": 2535,
	"./emblems/Wappen_Boezberg.png": 2536,
	"./emblems/Wappen_Boniswil.svg": 2537,
	"./emblems/Wappen_Boswil.svg": 2538,
	"./emblems/Wappen_Bottenwil.svg": 2539,
	"./emblems/Wappen_Bremgarten_AG.svg": 2540,
	"./emblems/Wappen_Brunegg.svg": 2541,
	"./emblems/Wappen_Bubikon.svg": 2542,
	"./emblems/Wappen_Buch.png": 2543,
	"./emblems/Wappen_Buchberg.png": 2544,
	"./emblems/Wappen_Buchs_AG.svg": 2545,
	"./emblems/Wappen_Buenzen_AG.svg": 2546,
	"./emblems/Wappen_Buerglen_UR.svg": 2547,
	"./emblems/Wappen_Buettenhardt.png": 2548,
	"./emblems/Wappen_Buettikon.svg": 2549,
	"./emblems/Wappen_Bussigny_VD.svg": 2550,
	"./emblems/Wappen_Buttwil.svg": 2551,
	"./emblems/Wappen_Chavannes-pres-Renens.svg": 2552,
	"./emblems/Wappen_Crissier.svg": 2553,
	"./emblems/Wappen_Densbueren.svg": 2554,
	"./emblems/Wappen_Diegten.png": 2555,
	"./emblems/Wappen_Dietwil.svg": 2556,
	"./emblems/Wappen_Dintikon.svg": 2557,
	"./emblems/Wappen_Dittingen.png": 2558,
	"./emblems/Wappen_Doerflingen.png": 2559,
	"./emblems/Wappen_Dottikon.svg": 2560,
	"./emblems/Wappen_Duerrenaesch.svg": 2561,
	"./emblems/Wappen_Duggingen.png": 2562,
	"./emblems/Wappen_Ecublens_VD.svg": 2563,
	"./emblems/Wappen_Eggenwil.svg": 2564,
	"./emblems/Wappen_Egliswil.svg": 2565,
	"./emblems/Wappen_Ehrendingen.svg": 2566,
	"./emblems/Wappen_Eiken.svg": 2567,
	"./emblems/Wappen_Endingen_2014.png": 2568,
	"./emblems/Wappen_Eptingen.png": 2569,
	"./emblems/Wappen_Erstfeld.svg": 2570,
	"./emblems/Wappen_Evionnaz.png": 2571,
	"./emblems/Wappen_Fahrwangen.svg": 2572,
	"./emblems/Wappen_Fey.png": 2573,
	"./emblems/Wappen_Fischbach-Goeslikon.svg": 2574,
	"./emblems/Wappen_Fisibach.svg": 2575,
	"./emblems/Wappen_Flawil.svg": 2576,
	"./emblems/Wappen_Flums.png": 2577,
	"./emblems/Wappen_Freienwil.svg": 2578,
	"./emblems/Wappen_Frenkendorf.png": 2579,
	"./emblems/Wappen_Frick_AG.svg": 2580,
	"./emblems/Wappen_Fuellinsdorf.png": 2581,
	"./emblems/Wappen_Full-Reuenthal.svg": 2582,
	"./emblems/Wappen_Gaechlingen.png": 2583,
	"./emblems/Wappen_Gansingen.svg": 2584,
	"./emblems/Wappen_Gebenstorf_AG.svg": 2585,
	"./emblems/Wappen_Geltwil.svg": 2586,
	"./emblems/Wappen_Genf_matt.svg": 2587,
	"./emblems/Wappen_Gersau.svg": 2588,
	"./emblems/Wappen_Gipf-Oberfrick.svg": 2589,
	"./emblems/Wappen_Gontenschwil.svg": 2590,
	"./emblems/Wappen_Graenichen_AG.svg": 2591,
	"./emblems/Wappen_Grengiols.png": 2592,
	"./emblems/Wappen_Habsburg_AG.svg": 2593,
	"./emblems/Wappen_Haegglingen.svg": 2594,
	"./emblems/Wappen_Hallau.png": 2595,
	"./emblems/Wappen_Hallwil.svg": 2596,
	"./emblems/Wappen_Hausen_AG.svg": 2597,
	"./emblems/Wappen_Hellikon_AG.svg": 2598,
	"./emblems/Wappen_Hemishofen.png": 2599,
	"./emblems/Wappen_Hendschiken.svg": 2600,
	"./emblems/Wappen_Hirschthal_AG.svg": 2601,
	"./emblems/Wappen_Hoelstein.svg": 2602,
	"./emblems/Wappen_Holderbank.svg": 2603,
	"./emblems/Wappen_Horn.svg": 2604,
	"./emblems/Wappen_Hospental.svg": 2605,
	"./emblems/Wappen_Ingenbohl.png": 2606,
	"./emblems/Wappen_Islisberg_AG.svg": 2607,
	"./emblems/Wappen_Itingen.svg": 2608,
	"./emblems/Wappen_Jonen_AG.svg": 2609,
	"./emblems/Wappen_Jonschwil.png": 2610,
	"./emblems/Wappen_Kaenerkinden.png": 2611,
	"./emblems/Wappen_Kaiseraugst_AG.svg": 2612,
	"./emblems/Wappen_Kaisten_AG.svg": 2613,
	"./emblems/Wappen_Kallern.svg": 2614,
	"./emblems/Wappen_Kaltbrunn.png": 2615,
	"./emblems/Wappen_Kirchberg.png": 2616,
	"./emblems/Wappen_Kirchleerau_AG.svg": 2617,
	"./emblems/Wappen_Klingnau.svg": 2618,
	"./emblems/Wappen_Koblenz_AG.svg": 2619,
	"./emblems/Wappen_Koelliken_AG.svg": 2620,
	"./emblems/Wappen_Kuenten.svg": 2621,
	"./emblems/Wappen_Kuettigen_AG.svg": 2622,
	"./emblems/Wappen_Laeufelfingen.png": 2623,
	"./emblems/Wappen_Langenbruck.png": 2624,
	"./emblems/Wappen_Laufen_BL.png": 2625,
	"./emblems/Wappen_Laufenburg_AG.svg": 2626,
	"./emblems/Wappen_Lausanne.svg": 2627,
	"./emblems/Wappen_Lengnau_AG.svg": 2628,
	"./emblems/Wappen_Les_Ponts-de-Martel.png": 2629,
	"./emblems/Wappen_Leukerbad.png": 2630,
	"./emblems/Wappen_Leutwil.svg": 2631,
	"./emblems/Wappen_Lichtensteig.svg": 2632,
	"./emblems/Wappen_Liedertswil.png": 2633,
	"./emblems/Wappen_Liesberg.png": 2634,
	"./emblems/Wappen_Loehningen.png": 2635,
	"./emblems/Wappen_Lohn.png": 2636,
	"./emblems/Wappen_Luetisburg.png": 2637,
	"./emblems/Wappen_Lupfig.svg": 2638,
	"./emblems/Wappen_Lupsingen.png": 2639,
	"./emblems/Wappen_Luzern_matt.svg": 2640,
	"./emblems/Wappen_Maegenwil_AG.svg": 2641,
	"./emblems/Wappen_Maerstetten-Ottoberg_horizontal.png": 2642,
	"./emblems/Wappen_Martigny.svg": 2643,
	"./emblems/Wappen_Mellingen_AG.svg": 2644,
	"./emblems/Wappen_Merishausen.png": 2645,
	"./emblems/Wappen_Moosleerau_AG.svg": 2646,
	"./emblems/Wappen_Mosnang.png": 2647,
	"./emblems/Wappen_Muenchenstein.png": 2648,
	"./emblems/Wappen_Muhen_AG.svg": 2649,
	"./emblems/Wappen_Mumpf_AG.svg": 2650,
	"./emblems/Wappen_Murgenthal_AG.svg": 2651,
	"./emblems/Wappen_Murten.svg": 2652,
	"./emblems/Wappen_Muttenz.png": 2653,
	"./emblems/Wappen_Nenzlingen.png": 2654,
	"./emblems/Wappen_Nesslau-Krummenau.png": 2655,
	"./emblems/Wappen_Neuhausen_am_Rheinfall.png": 2656,
	"./emblems/Wappen_Neunkirch.png": 2657,
	"./emblems/Wappen_Niederrohrdorf_AG.svg": 2658,
	"./emblems/Wappen_Oberentfelden_AG.svg": 2659,
	"./emblems/Wappen_Oberhallau.png": 2660,
	"./emblems/Wappen_Oberlunkhofen_AG.svg": 2661,
	"./emblems/Wappen_Oberriet.png": 2662,
	"./emblems/Wappen_Oberrohrdorf_AG.svg": 2663,
	"./emblems/Wappen_Obersiggenthal_AG.svg": 2664,
	"./emblems/Wappen_Oberwil-Lieli_AG.svg": 2665,
	"./emblems/Wappen_Orbe.svg": 2666,
	"./emblems/Wappen_Pfaefers.png": 2667,
	"./emblems/Wappen_Ramsen.png": 2668,
	"./emblems/Wappen_Randa.png": 2669,
	"./emblems/Wappen_Raron.gif": 4068,
	"./emblems/Wappen_Regensberg.svg": 2670,
	"./emblems/Wappen_Reigoldswil.png": 2671,
	"./emblems/Wappen_Reitnau_AG.svg": 2672,
	"./emblems/Wappen_Remetschwil_AG.svg": 2673,
	"./emblems/Wappen_Remigen_AG.svg": 2674,
	"./emblems/Wappen_Renens.svg": 2675,
	"./emblems/Wappen_Riederalp_16.07.08.png": 2676,
	"./emblems/Wappen_Riniken_AG.svg": 2677,
	"./emblems/Wappen_Risch_Rotkreuz.svg": 2678,
	"./emblems/Wappen_Roeschenz.png": 2679,
	"./emblems/Wappen_Roggenburg_BL.png": 2680,
	"./emblems/Wappen_Romanshorn.svg": 2681,
	"./emblems/Wappen_Rothrist_AG.svg": 2682,
	"./emblems/Wappen_Ruedlingen.png": 2683,
	"./emblems/Wappen_Ruefenach_AG.svg": 2684,
	"./emblems/Wappen_Ruemlingen.png": 2685,
	"./emblems/Wappen_Safenwil_AG.svg": 2686,
	"./emblems/Wappen_Salenstein.png": 2687,
	"./emblems/Wappen_Salgesch.svg": 2688,
	"./emblems/Wappen_Sarmenstorf_AG.svg": 2689,
	"./emblems/Wappen_Schaffhausen.png": 2690,
	"./emblems/Wappen_Schattdorf.svg": 2691,
	"./emblems/Wappen_Schleitheim.png": 2692,
	"./emblems/Wappen_Schmerikon.svg": 2693,
	"./emblems/Wappen_Schoenenbuch.png": 2694,
	"./emblems/Wappen_Seedorf_UR.svg": 2695,
	"./emblems/Wappen_Seelisberg_UR.svg": 2696,
	"./emblems/Wappen_Siblingen.png": 2697,
	"./emblems/Wappen_Silenen.svg": 2698,
	"./emblems/Wappen_Simplon.png": 2699,
	"./emblems/Wappen_Sissach.png": 2700,
	"./emblems/Wappen_Solothurn_matt.svg": 2701,
	"./emblems/Wappen_Spreitenbach_AG.svg": 2702,
	"./emblems/Wappen_St_Maurice.svg": 2703,
	"./emblems/Wappen_Stadt_Wil_SG.svg": 2704,
	"./emblems/Wappen_Staffelbach_AG.svg": 2705,
	"./emblems/Wappen_Steckborn.png": 2706,
	"./emblems/Wappen_Stetten.png": 2707,
	"./emblems/Wappen_Suhr_AG.svg": 2708,
	"./emblems/Wappen_Sumvitg.png": 2709,
	"./emblems/Wappen_Taegerig_AG.svg": 2710,
	"./emblems/Wappen_Teufen.png": 2711,
	"./emblems/Wappen_Thalheim_AG.svg": 2712,
	"./emblems/Wappen_Titterten.png": 2713,
	"./emblems/Wappen_Trasadingen.png": 2714,
	"./emblems/Wappen_Unterentfelden.svg": 2715,
	"./emblems/Wappen_Untersiggenthal_AG.svg": 2716,
	"./emblems/Wappen_Uznach.svg": 2717,
	"./emblems/Wappen_Veltheim_AG.svg": 2718,
	"./emblems/Wappen_Villars-Sainte-Croix.svg": 2719,
	"./emblems/Wappen_Vordemwald_AG.svg": 2720,
	"./emblems/Wappen_Waengi.svg": 2721,
	"./emblems/Wappen_Wahlen.png": 2722,
	"./emblems/Wappen_Wartau.svg": 2723,
	"./emblems/Wappen_Wassen.svg": 2724,
	"./emblems/Wappen_Wattwil.svg": 2725,
	"./emblems/Wappen_Weesen.svg": 2726,
	"./emblems/Wappen_Weinfelden.png": 2727,
	"./emblems/Wappen_Widen_AG.svg": 2728,
	"./emblems/Wappen_Wilchingen.png": 2729,
	"./emblems/Wappen_Wiliberg_AG.svg": 2730,
	"./emblems/Wappen_Winterthur.svg": 2731,
	"./emblems/Wappen_Wohlenschwil_AG.svg": 2732,
	"./emblems/Wappen_Wuerenlingen_AG.svg": 2733,
	"./emblems/Wappen_Wuerenlos_AG.svg": 2734,
	"./emblems/Wappen_Zernez_neu.png": 2735,
	"./emblems/Wappen_Ziefen.png": 2736,
	"./emblems/Wappen_Zuerich_matt.svg": 2737,
	"./emblems/Wappen_Zufikon_AG.svg": 2738,
	"./emblems/Wappen_alpthal.png": 2739,
	"./emblems/Wappen_altendorf.png": 2740,
	"./emblems/Wappen_arth.png": 2741,
	"./emblems/Wappen_balsthal.png": 2742,
	"./emblems/Wappen_der_Gemeinde_Wichtrach.svg": 2743,
	"./emblems/Wappen_des_Kantons_Schwyz.svg": 2744,
	"./emblems/Wappen_feusisberg.png": 2745,
	"./emblems/Wappen_freienbach.png": 2746,
	"./emblems/Wappen_galgenen.png": 2747,
	"./emblems/Wappen_gampel_bratsch_jpg": 492,
	"./emblems/Wappen_gampel_bratsch_jpg.png": 492,
	"./emblems/Wappen_illgau.png": 2748,
	"./emblems/Wappen_innterthal.png": 2749,
	"./emblems/Wappen_kuessnacht.png": 2750,
	"./emblems/Wappen_lachen.png": 2751,
	"./emblems/Wappen_lauerz.png": 2752,
	"./emblems/Wappen_morschach.png": 2753,
	"./emblems/Wappen_muotathal.png": 2754,
	"./emblems/Wappen_oberiberg.png": 2755,
	"./emblems/Wappen_reichenburg.png": 2756,
	"./emblems/Wappen_riemenstalden.png": 2757,
	"./emblems/Wappen_rothenthurm.png": 2758,
	"./emblems/Wappen_saas-almagell.png": 2759,
	"./emblems/Wappen_sattel.png": 2760,
	"./emblems/Wappen_schoenholzerswilen.png": 2761,
	"./emblems/Wappen_schuebelbach.png": 2762,
	"./emblems/Wappen_steinen.png": 2763,
	"./emblems/Wappen_steinerberg.png": 2764,
	"./emblems/Wappen_toerbel.png": 2765,
	"./emblems/Wappen_tuggen.png": 2766,
	"./emblems/Wappen_unteriberg.png": 2767,
	"./emblems/Wappen_von_Kesswil.gif": 4069,
	"./emblems/Wappen_vorderthal.png": 2768,
	"./emblems/Wappen_wangen.png": 2769,
	"./emblems/Wappen_wollerau.png": 2770,
	"./emblems/Wappeneggerberg.png": 2771,
	"./emblems/Warth-Weiningen-Blazono.png": 2772,
	"./emblems/Wasterkingen.svg": 2773,
	"./emblems/Wattenwil-coat_of_arms.svg": 2774,
	"./emblems/Wauwil_LU.png": 2775,
	"./emblems/Wegenstetten-blason.png": 2776,
	"./emblems/Weggis_LU.png": 2777,
	"./emblems/Weiach.svg": 2778,
	"./emblems/Weiningen-blazon.svg": 2779,
	"./emblems/Weisslingen-blazon.svg": 2780,
	"./emblems/Welschenrohr-blazon.svg": 2781,
	"./emblems/Wengi_bei_Bueren-coat_of_arms.svg": 2782,
	"./emblems/Werthenstein_LU.png": 2783,
	"./emblems/Wettswil_am_Albis-blazon.svg": 2784,
	"./emblems/Wetzikon-blazon.svg": 2785,
	"./emblems/Widnau.png": 2786,
	"./emblems/Wiedlisbach-coat_of_arms.svg": 2787,
	"./emblems/Wiesendangen-blazon.svg": 2788,
	"./emblems/Wiggiswil-coat_of_arms.svg": 2789,
	"./emblems/Wikon_LU.png": 2790,
	"./emblems/Wil-blazon.svg": 2791,
	"./emblems/Wila-blazon.svg": 2792,
	"./emblems/Wildberg-blazon.svg": 2793,
	"./emblems/Wilderswil-coat_of_arms.svg": 2794,
	"./emblems/Wilenr.png": 2795,
	"./emblems/Wiler.png": 2796,
	"./emblems/Wiler_bei_Utzenstorf-coat_of_arms.svg": 2797,
	"./emblems/Wileroltigen-coat_of_arms.svg": 2798,
	"./emblems/Willadingen-coat_of_arms.svg": 2799,
	"./emblems/Willisau_Stadt_LU.png": 2800,
	"./emblems/Wimmis-coat_of_arms.svg": 2801,
	"./emblems/Windisch-blason.png": 2802,
	"./emblems/Winkel.svg": 2803,
	"./emblems/Winznau-blason.png": 2804,
	"./emblems/Wisen-blason.png": 2805,
	"./emblems/Wittenba.png": 2806,
	"./emblems/Witterswil-blason.png": 2807,
	"./emblems/Wittnau-blason.png": 2808,
	"./emblems/Woelflinswil-blason.png": 2809,
	"./emblems/Wohlen_bei_Bern-coat_of_arms.svg": 2810,
	"./emblems/Wolfenschiessen-coat_of_arms.svg": 2811,
	"./emblems/Wolfhald.png": 2812,
	"./emblems/Wolfwil-blason.png": 2813,
	"./emblems/Wolhusen_LU.png": 2814,
	"./emblems/Worb-coat_of_arms.svg": 2815,
	"./emblems/Worben-coat_of_arms.svg": 2816,
	"./emblems/Wuennewil-Flamatt-coat_of_arms.svg": 2817,
	"./emblems/Wuppenau-Blazono.png": 2818,
	"./emblems/Wynau-coat_of_arms.svg": 2819,
	"./emblems/Wynigen-coat_of_arms.svg": 2820,
	"./emblems/Wyssachen-coat_of_arms.svg": 2821,
	"./emblems/Yens-coat_of_arms.svg": 2822,
	"./emblems/Yverdon-Les-Bains-coat_of_arms.svg": 2823,
	"./emblems/Yvonand-coat_of_arms.svg": 2824,
	"./emblems/Zaeziwil-coat_of_arms.svg": 2825,
	"./emblems/Zeihen-blason.png": 2826,
	"./emblems/Zeiningen-blason.png": 2827,
	"./emblems/Zell-blazon-variant-2.svg": 2828,
	"./emblems/Zell_LU.png": 2829,
	"./emblems/Zeneggen.png": 2830,
	"./emblems/Zermatt_Wappen.svg": 2831,
	"./emblems/Zetzwil-blason.png": 2832,
	"./emblems/Zielebach-coat_of_arms.svg": 2833,
	"./emblems/ZihlschlachtSitterdorf-blazon.svg": 2834,
	"./emblems/Zillis-Reischen_wappen.svg": 2835,
	"./emblems/Zizers_wappen.svg": 2836,
	"./emblems/Zollikofen-coat_of_arms.svg": 2837,
	"./emblems/Zoug-ville-blason.svg": 2838,
	"./emblems/Zuchwil-blason.png": 2839,
	"./emblems/Zullwil-blason.png": 2840,
	"./emblems/Zumikon-blazon.svg": 2841,
	"./emblems/Zuoz_wappen.svg": 2842,
	"./emblems/Zuzgen-blason.png": 2843,
	"./emblems/Zuzwil-coat_of_arms.svg": 2844,
	"./emblems/Zuzwilsg.png": 2845,
	"./emblems/fieschertal.png": 2846,
	"./emblems/wappen_oberems.png": 2847,
	"./emblems/wappen_von_berneck.png": 2848,
	"./emblems/wappenwalchwil.png": 2849,
	"./expert__ana-maria-markovic.jpg": 2850,
	"./expert__ana-maria-marković.jpg": 2851,
	"./expert__daniel-gygax.jpg": 2852,
	"./expert__placeholder--left.png": 2853,
	"./expert__placeholder--right.png": 2854,
	"./expert__selectedArrow--dark.png": 2855,
	"./expert__selectedArrow.png": 2856,
	"./fantasy_logo--dark.svg": 2857,
	"./fantasy_logo.png": 2858,
	"./fantasy_logo.svg": 2859,
	"./fantasy_logo_fr--dark.svg": 2860,
	"./fantasy_logo_fr.svg": 2861,
	"./favicon.png": 2862,
	"./flags/AD.svg": 161,
	"./flags/AE.svg": 162,
	"./flags/AF.svg": 163,
	"./flags/AG.svg": 164,
	"./flags/AI.svg": 165,
	"./flags/AL.svg": 166,
	"./flags/AM.svg": 167,
	"./flags/AO.svg": 168,
	"./flags/AR.svg": 169,
	"./flags/AS.svg": 170,
	"./flags/AT.svg": 171,
	"./flags/AU.svg": 172,
	"./flags/AW.svg": 173,
	"./flags/AX.svg": 174,
	"./flags/AZ.svg": 175,
	"./flags/BA.svg": 176,
	"./flags/BB.svg": 177,
	"./flags/BD.svg": 178,
	"./flags/BE.svg": 179,
	"./flags/BF.svg": 180,
	"./flags/BG.svg": 181,
	"./flags/BH.svg": 182,
	"./flags/BI.svg": 183,
	"./flags/BJ.svg": 184,
	"./flags/BL.svg": 185,
	"./flags/BM.svg": 186,
	"./flags/BN.svg": 187,
	"./flags/BO.svg": 188,
	"./flags/BR.svg": 189,
	"./flags/BS.svg": 190,
	"./flags/BT.svg": 191,
	"./flags/BV.svg": 192,
	"./flags/BW.svg": 193,
	"./flags/BY.svg": 194,
	"./flags/BZ.svg": 195,
	"./flags/CA.svg": 196,
	"./flags/CC.svg": 197,
	"./flags/CD.svg": 198,
	"./flags/CF.svg": 199,
	"./flags/CG.svg": 200,
	"./flags/CH.svg": 201,
	"./flags/CI.svg": 202,
	"./flags/CK.svg": 203,
	"./flags/CL.svg": 204,
	"./flags/CM.svg": 205,
	"./flags/CN.svg": 206,
	"./flags/CO.svg": 207,
	"./flags/CR.svg": 208,
	"./flags/CU.svg": 209,
	"./flags/CV.svg": 210,
	"./flags/CW.svg": 211,
	"./flags/CX.svg": 212,
	"./flags/CY.svg": 213,
	"./flags/CZ.svg": 214,
	"./flags/DE.svg": 215,
	"./flags/DJ.svg": 216,
	"./flags/DK.svg": 217,
	"./flags/DM.svg": 218,
	"./flags/DO.svg": 219,
	"./flags/DZ.svg": 220,
	"./flags/EC.svg": 221,
	"./flags/EE.svg": 222,
	"./flags/EG.svg": 223,
	"./flags/ER.svg": 224,
	"./flags/ES.svg": 225,
	"./flags/ET.svg": 226,
	"./flags/EU.svg": 227,
	"./flags/FI.svg": 228,
	"./flags/FJ.svg": 229,
	"./flags/FK.svg": 230,
	"./flags/FM.svg": 231,
	"./flags/FO.svg": 232,
	"./flags/FR.svg": 233,
	"./flags/GA.svg": 234,
	"./flags/GB-ENG.svg": 235,
	"./flags/GB-NIR.svg": 236,
	"./flags/GB-SCT.svg": 237,
	"./flags/GB-WLS.svg": 238,
	"./flags/GB-ZET.svg": 239,
	"./flags/GB.svg": 240,
	"./flags/GD.svg": 241,
	"./flags/GE.svg": 242,
	"./flags/GF.svg": 243,
	"./flags/GG.svg": 244,
	"./flags/GH.svg": 245,
	"./flags/GI.svg": 246,
	"./flags/GL.svg": 247,
	"./flags/GM.svg": 248,
	"./flags/GN.svg": 249,
	"./flags/GP.svg": 250,
	"./flags/GQ.svg": 251,
	"./flags/GR.svg": 252,
	"./flags/GS.svg": 253,
	"./flags/GT.svg": 254,
	"./flags/GU.svg": 255,
	"./flags/GW.svg": 256,
	"./flags/GY.svg": 257,
	"./flags/HK.svg": 258,
	"./flags/HM.svg": 259,
	"./flags/HN.svg": 260,
	"./flags/HR.svg": 261,
	"./flags/HT.svg": 262,
	"./flags/HU.svg": 263,
	"./flags/ID.svg": 264,
	"./flags/IE.svg": 265,
	"./flags/IL.svg": 266,
	"./flags/IM.svg": 267,
	"./flags/IN.svg": 268,
	"./flags/IO.svg": 269,
	"./flags/IQ.svg": 270,
	"./flags/IR.svg": 271,
	"./flags/IS.svg": 272,
	"./flags/IT.svg": 273,
	"./flags/JE.svg": 274,
	"./flags/JM.svg": 275,
	"./flags/JO.svg": 276,
	"./flags/JP.svg": 277,
	"./flags/KE.svg": 278,
	"./flags/KG.svg": 279,
	"./flags/KH.svg": 280,
	"./flags/KI.svg": 281,
	"./flags/KM.svg": 282,
	"./flags/KN.svg": 283,
	"./flags/KP.svg": 284,
	"./flags/KR.svg": 285,
	"./flags/KW.svg": 286,
	"./flags/KY.svg": 287,
	"./flags/KZ.svg": 288,
	"./flags/LA.svg": 289,
	"./flags/LB.svg": 290,
	"./flags/LC.svg": 291,
	"./flags/LGBT.svg": 292,
	"./flags/LI.svg": 293,
	"./flags/LK.svg": 294,
	"./flags/LR.svg": 295,
	"./flags/LS.svg": 296,
	"./flags/LT.svg": 297,
	"./flags/LU.svg": 298,
	"./flags/LV.svg": 299,
	"./flags/LY.svg": 300,
	"./flags/MA.svg": 301,
	"./flags/MC.svg": 302,
	"./flags/MD.svg": 303,
	"./flags/ME.svg": 304,
	"./flags/MF.svg": 305,
	"./flags/MG.svg": 306,
	"./flags/MH.svg": 307,
	"./flags/MK.svg": 308,
	"./flags/ML.svg": 309,
	"./flags/MM.svg": 310,
	"./flags/MN.svg": 311,
	"./flags/MO.svg": 312,
	"./flags/MP.svg": 313,
	"./flags/MQ.svg": 314,
	"./flags/MR.svg": 315,
	"./flags/MS.svg": 316,
	"./flags/MT.svg": 317,
	"./flags/MU.svg": 318,
	"./flags/MV.svg": 319,
	"./flags/MW.svg": 320,
	"./flags/MX.svg": 321,
	"./flags/MY.svg": 322,
	"./flags/MZ.svg": 323,
	"./flags/NA.svg": 324,
	"./flags/NC.svg": 325,
	"./flags/NE.svg": 326,
	"./flags/NF.svg": 327,
	"./flags/NG.svg": 328,
	"./flags/NI.svg": 329,
	"./flags/NL.svg": 330,
	"./flags/NO.svg": 331,
	"./flags/NP.svg": 332,
	"./flags/NR.svg": 333,
	"./flags/NU.svg": 334,
	"./flags/NZ.svg": 335,
	"./flags/OM.svg": 336,
	"./flags/PA.svg": 337,
	"./flags/PE.svg": 338,
	"./flags/PF.svg": 339,
	"./flags/PG.svg": 340,
	"./flags/PH.svg": 341,
	"./flags/PK.svg": 342,
	"./flags/PL.svg": 343,
	"./flags/PM.svg": 344,
	"./flags/PN.svg": 345,
	"./flags/PR.svg": 346,
	"./flags/PS.svg": 347,
	"./flags/PT.svg": 348,
	"./flags/PW.svg": 349,
	"./flags/PY.svg": 350,
	"./flags/QA.svg": 351,
	"./flags/RE.svg": 352,
	"./flags/RO.svg": 353,
	"./flags/RS.svg": 354,
	"./flags/RU.svg": 355,
	"./flags/RW.svg": 356,
	"./flags/SA.svg": 357,
	"./flags/SB.svg": 358,
	"./flags/SC.svg": 359,
	"./flags/SD.svg": 360,
	"./flags/SE.svg": 361,
	"./flags/SG.svg": 362,
	"./flags/SH.svg": 363,
	"./flags/SI.svg": 364,
	"./flags/SJ.svg": 365,
	"./flags/SK.svg": 366,
	"./flags/SL.svg": 367,
	"./flags/SM.svg": 368,
	"./flags/SN.svg": 369,
	"./flags/SO.svg": 370,
	"./flags/SR.svg": 371,
	"./flags/SS.svg": 372,
	"./flags/ST.svg": 373,
	"./flags/SV.svg": 374,
	"./flags/SX.svg": 375,
	"./flags/SY.svg": 376,
	"./flags/SZ.svg": 377,
	"./flags/TC.svg": 378,
	"./flags/TD.svg": 379,
	"./flags/TF.svg": 380,
	"./flags/TG.svg": 381,
	"./flags/TH.svg": 382,
	"./flags/TJ.svg": 383,
	"./flags/TK.svg": 384,
	"./flags/TL.svg": 385,
	"./flags/TM.svg": 386,
	"./flags/TN.svg": 387,
	"./flags/TO.svg": 388,
	"./flags/TR.svg": 389,
	"./flags/TT.svg": 390,
	"./flags/TV.svg": 391,
	"./flags/TW.svg": 392,
	"./flags/TZ.svg": 393,
	"./flags/UA.svg": 394,
	"./flags/UG.svg": 395,
	"./flags/UM.svg": 396,
	"./flags/US-CA.svg": 397,
	"./flags/US.svg": 398,
	"./flags/UY.svg": 399,
	"./flags/UZ.svg": 400,
	"./flags/VA.svg": 401,
	"./flags/VC.svg": 402,
	"./flags/VE.svg": 403,
	"./flags/VG.svg": 404,
	"./flags/VI.svg": 405,
	"./flags/VN.svg": 406,
	"./flags/VU.svg": 407,
	"./flags/WF.svg": 408,
	"./flags/WS.svg": 409,
	"./flags/XK.svg": 410,
	"./flags/YE.svg": 411,
	"./flags/YT.svg": 412,
	"./flags/ZA.svg": 413,
	"./flags/ZM.svg": 414,
	"./flags/ZW.svg": 415,
	"./gameLogo--fr.png": 2863,
	"./gameLogo.png": 2864,
	"./gradient.png": 2865,
	"./groupRank__eval--correct@3x.png": 2866,
	"./groupRank__eval--wrong@3x.png": 2867,
	"./groupphasebet__sample@2x.png": 2868,
	"./header__background.jpg": 2869,
	"./header__bg.jpg": 2870,
	"./iconAccount.png": 2871,
	"./iconArrowDown.png": 2872,
	"./iconArrowLeft--dark.png": 2873,
	"./iconArrowLeft.png": 2874,
	"./iconArrowRight--dark.png": 2875,
	"./iconArrowRight.png": 472,
	"./iconArrowUp.png": 2876,
	"./iconBell--dark.png": 2877,
	"./iconBell.png": 2878,
	"./iconBell__accent--dark.png": 2879,
	"./iconBell__accent.png": 2880,
	"./iconBell__errorRed--dark.png": 2881,
	"./iconBell__errorRed.png": 2882,
	"./iconBell__inFrontOfAccent--dark.png": 2883,
	"./iconBell__inFrontOfAccent.png": 2884,
	"./iconBell__inactive--dark.png": 2885,
	"./iconBell__inactive.png": 2886,
	"./iconBell__okGreen--dark.png": 2887,
	"./iconBell__okGreen.png": 2888,
	"./iconCheck--dark.png": 2889,
	"./iconCheck.png": 2890,
	"./iconCheck__accent--dark.png": 2891,
	"./iconCheck__accent.png": 2892,
	"./iconCheck__errorRed--dark.png": 2893,
	"./iconCheck__errorRed.png": 2894,
	"./iconCheck__inFrontOfAccent--dark.png": 2895,
	"./iconCheck__inFrontOfAccent.png": 2896,
	"./iconCheck__inactive--dark.png": 2897,
	"./iconCheck__inactive.png": 2898,
	"./iconCheck__okGreen--dark.png": 2899,
	"./iconCheck__okGreen.png": 2900,
	"./iconClipboard.png": 2901,
	"./iconClose--dark.png": 2902,
	"./iconClose.png": 2903,
	"./iconClose__accent--dark.png": 2904,
	"./iconClose__accent.png": 2905,
	"./iconClose__errorRed--dark.png": 2906,
	"./iconClose__errorRed.png": 2907,
	"./iconClose__inFrontOfAccent--dark.png": 2908,
	"./iconClose__inFrontOfAccent.png": 2909,
	"./iconClose__inactive--dark.png": 2910,
	"./iconClose__inactive.png": 2911,
	"./iconClose__okGreen--dark.png": 2912,
	"./iconClose__okGreen.png": 2913,
	"./iconDelete--dark.png": 2914,
	"./iconDelete.png": 2915,
	"./iconDelete__accent--dark.png": 2916,
	"./iconDelete__accent.png": 2917,
	"./iconDelete__errorRed--dark.png": 2918,
	"./iconDelete__errorRed.png": 2919,
	"./iconDelete__inFrontOfAccent--dark.png": 2920,
	"./iconDelete__inFrontOfAccent.png": 2921,
	"./iconDelete__inactive--dark.png": 2922,
	"./iconDelete__inactive.png": 2923,
	"./iconDelete__okGreen--dark.png": 2924,
	"./iconDelete__okGreen.png": 2925,
	"./iconDown--dark.png": 2926,
	"./iconDown.png": 2927,
	"./iconDown__accent--dark.png": 2928,
	"./iconDown__accent.png": 2929,
	"./iconDown__errorRed--dark.png": 2930,
	"./iconDown__errorRed.png": 2931,
	"./iconDown__inFrontOfAccent--dark.png": 2932,
	"./iconDown__inFrontOfAccent.png": 2933,
	"./iconDown__inactive--dark.png": 2934,
	"./iconDown__inactive.png": 2935,
	"./iconDown__okGreen--dark.png": 2936,
	"./iconDown__okGreen.png": 2937,
	"./iconEdit--dark.png": 2938,
	"./iconEdit.png": 2939,
	"./iconEdit__accent--dark.png": 2940,
	"./iconEdit__accent.png": 2941,
	"./iconEdit__errorRed--dark.png": 2942,
	"./iconEdit__errorRed.png": 2943,
	"./iconEdit__inFrontOfAccent--dark.png": 2944,
	"./iconEdit__inFrontOfAccent.png": 2945,
	"./iconEdit__inactive--dark.png": 2946,
	"./iconEdit__inactive.png": 2947,
	"./iconEdit__okGreen--dark.png": 2948,
	"./iconEdit__okGreen.png": 2949,
	"./iconInfo--dark.png": 2950,
	"./iconInfo.png": 2951,
	"./iconInfoCircle--red.png": 2952,
	"./iconInfoCircle.png": 2953,
	"./iconInfo__accent--dark.png": 2954,
	"./iconInfo__accent.png": 2955,
	"./iconInfo__errorRed--dark.png": 2956,
	"./iconInfo__errorRed.png": 2957,
	"./iconInfo__inFrontOfAccent--dark.png": 2958,
	"./iconInfo__inFrontOfAccent.png": 2959,
	"./iconInfo__inactive--dark.png": 2960,
	"./iconInfo__inactive.png": 2961,
	"./iconInfo__okGreen--dark.png": 2962,
	"./iconInfo__okGreen.png": 2963,
	"./iconLeft--dark.png": 2964,
	"./iconLeft.png": 2965,
	"./iconLeft__accent--dark.png": 2966,
	"./iconLeft__accent.png": 2967,
	"./iconLeft__errorRed--dark.png": 2968,
	"./iconLeft__errorRed.png": 2969,
	"./iconLeft__inFrontOfAccent--dark.png": 2970,
	"./iconLeft__inFrontOfAccent.png": 2971,
	"./iconLeft__inactive--dark.png": 2972,
	"./iconLeft__inactive.png": 2973,
	"./iconLeft__okGreen--dark.png": 2974,
	"./iconLeft__okGreen.png": 2975,
	"./iconLoading.png": 2976,
	"./iconLock.png": 2977,
	"./iconLockClosed--dark.png": 2978,
	"./iconLockClosed.png": 2979,
	"./iconLockClosed__accent--dark.png": 2980,
	"./iconLockClosed__accent.png": 2981,
	"./iconLockClosed__errorRed--dark.png": 2982,
	"./iconLockClosed__errorRed.png": 2983,
	"./iconLockClosed__inFrontOfAccent--dark.png": 2984,
	"./iconLockClosed__inFrontOfAccent.png": 2985,
	"./iconLockClosed__inactive--dark.png": 2986,
	"./iconLockClosed__inactive.png": 2987,
	"./iconLockClosed__okGreen--dark.png": 2988,
	"./iconLockClosed__okGreen.png": 2989,
	"./iconLockOpen--dark.png": 2990,
	"./iconLockOpen.png": 2991,
	"./iconLockOpen__accent--dark.png": 2992,
	"./iconLockOpen__accent.png": 2993,
	"./iconLockOpen__errorRed--dark.png": 2994,
	"./iconLockOpen__errorRed.png": 2995,
	"./iconLockOpen__inFrontOfAccent--dark.png": 2996,
	"./iconLockOpen__inFrontOfAccent.png": 2997,
	"./iconLockOpen__inactive--dark.png": 2998,
	"./iconLockOpen__inactive.png": 2999,
	"./iconLockOpen__okGreen--dark.png": 3000,
	"./iconLockOpen__okGreen.png": 3001,
	"./iconNavMenu.png": 3002,
	"./iconPaginateFirst--dark.png": 3003,
	"./iconPaginateFirst.png": 3004,
	"./iconPaginateFirst__accent--dark.png": 3005,
	"./iconPaginateFirst__accent.png": 3006,
	"./iconPaginateFirst__errorRed--dark.png": 3007,
	"./iconPaginateFirst__errorRed.png": 3008,
	"./iconPaginateFirst__inFrontOfAccent--dark.png": 3009,
	"./iconPaginateFirst__inFrontOfAccent.png": 3010,
	"./iconPaginateFirst__inactive--dark.png": 3011,
	"./iconPaginateFirst__inactive.png": 3012,
	"./iconPaginateFirst__okGreen--dark.png": 3013,
	"./iconPaginateFirst__okGreen.png": 3014,
	"./iconPaginateLast--dark.png": 3015,
	"./iconPaginateLast.png": 3016,
	"./iconPaginateLast__accent--dark.png": 3017,
	"./iconPaginateLast__accent.png": 3018,
	"./iconPaginateLast__errorRed--dark.png": 3019,
	"./iconPaginateLast__errorRed.png": 3020,
	"./iconPaginateLast__inFrontOfAccent--dark.png": 3021,
	"./iconPaginateLast__inFrontOfAccent.png": 3022,
	"./iconPaginateLast__inactive--dark.png": 3023,
	"./iconPaginateLast__inactive.png": 3024,
	"./iconPaginateLast__okGreen--dark.png": 3025,
	"./iconPaginateLast__okGreen.png": 3026,
	"./iconPaginateNext--dark.png": 3027,
	"./iconPaginateNext.png": 3028,
	"./iconPaginateNext__accent--dark.png": 3029,
	"./iconPaginateNext__accent.png": 3030,
	"./iconPaginateNext__errorRed--dark.png": 3031,
	"./iconPaginateNext__errorRed.png": 3032,
	"./iconPaginateNext__inFrontOfAccent--dark.png": 3033,
	"./iconPaginateNext__inFrontOfAccent.png": 3034,
	"./iconPaginateNext__inactive--dark.png": 3035,
	"./iconPaginateNext__inactive.png": 3036,
	"./iconPaginateNext__okGreen--dark.png": 3037,
	"./iconPaginateNext__okGreen.png": 3038,
	"./iconPaginatePrev--dark.png": 3039,
	"./iconPaginatePrev.png": 3040,
	"./iconPaginatePrev__accent--dark.png": 3041,
	"./iconPaginatePrev__accent.png": 3042,
	"./iconPaginatePrev__errorRed--dark.png": 3043,
	"./iconPaginatePrev__errorRed.png": 3044,
	"./iconPaginatePrev__inFrontOfAccent--dark.png": 3045,
	"./iconPaginatePrev__inFrontOfAccent.png": 3046,
	"./iconPaginatePrev__inactive--dark.png": 3047,
	"./iconPaginatePrev__inactive.png": 3048,
	"./iconPaginatePrev__okGreen--dark.png": 3049,
	"./iconPaginatePrev__okGreen.png": 3050,
	"./iconPlus--dark.png": 3051,
	"./iconPlus.png": 3052,
	"./iconPlus__accent--dark.png": 3053,
	"./iconPlus__accent.png": 3054,
	"./iconPlus__errorRed--dark.png": 3055,
	"./iconPlus__errorRed.png": 3056,
	"./iconPlus__inFrontOfAccent--dark.png": 3057,
	"./iconPlus__inFrontOfAccent.png": 3058,
	"./iconPlus__inactive--dark.png": 3059,
	"./iconPlus__inactive.png": 3060,
	"./iconPlus__okGreen--dark.png": 3061,
	"./iconPlus__okGreen.png": 3062,
	"./iconRight--dark.png": 3063,
	"./iconRight.png": 3064,
	"./iconRight__accent--dark.png": 3065,
	"./iconRight__accent.png": 3066,
	"./iconRight__errorRed--dark.png": 3067,
	"./iconRight__errorRed.png": 3068,
	"./iconRight__inFrontOfAccent--dark.png": 3069,
	"./iconRight__inFrontOfAccent.png": 3070,
	"./iconRight__inactive--dark.png": 3071,
	"./iconRight__inactive.png": 3072,
	"./iconRight__okGreen--dark.png": 3073,
	"./iconRight__okGreen.png": 3074,
	"./iconSearch--dark.png": 3075,
	"./iconSearch.png": 3076,
	"./iconSearch__accent--dark.png": 3077,
	"./iconSearch__accent.png": 3078,
	"./iconSearch__errorRed--dark.png": 3079,
	"./iconSearch__errorRed.png": 3080,
	"./iconSearch__inFrontOfAccent--dark.png": 3081,
	"./iconSearch__inFrontOfAccent.png": 3082,
	"./iconSearch__inactive--dark.png": 3083,
	"./iconSearch__inactive.png": 3084,
	"./iconSearch__okGreen--dark.png": 3085,
	"./iconSearch__okGreen.png": 3086,
	"./iconSettings--dark.png": 3087,
	"./iconSettings.png": 3088,
	"./iconSettings__accent--dark.png": 3089,
	"./iconSettings__accent.png": 3090,
	"./iconSettings__errorRed--dark.png": 3091,
	"./iconSettings__errorRed.png": 3092,
	"./iconSettings__inFrontOfAccent--dark.png": 3093,
	"./iconSettings__inFrontOfAccent.png": 3094,
	"./iconSettings__inactive--dark.png": 3095,
	"./iconSettings__inactive.png": 3096,
	"./iconSettings__okGreen--dark.png": 3097,
	"./iconSettings__okGreen.png": 3098,
	"./iconShop.png": 3099,
	"./iconSignIn.png": 3100,
	"./iconSocialFacebook--dark.png": 3101,
	"./iconSocialFacebook.png": 3102,
	"./iconSocialFacebook__accent--dark.png": 3103,
	"./iconSocialFacebook__accent.png": 3104,
	"./iconSocialFacebook__errorRed--dark.png": 3105,
	"./iconSocialFacebook__errorRed.png": 3106,
	"./iconSocialFacebook__inFrontOfAccent--dark.png": 3107,
	"./iconSocialFacebook__inFrontOfAccent.png": 3108,
	"./iconSocialFacebook__inactive--dark.png": 3109,
	"./iconSocialFacebook__inactive.png": 3110,
	"./iconSocialFacebook__okGreen--dark.png": 3111,
	"./iconSocialFacebook__okGreen.png": 3112,
	"./iconSocialLink--dark.png": 3113,
	"./iconSocialLink.png": 3114,
	"./iconSocialLink__accent--dark.png": 3115,
	"./iconSocialLink__accent.png": 3116,
	"./iconSocialLink__errorRed--dark.png": 3117,
	"./iconSocialLink__errorRed.png": 3118,
	"./iconSocialLink__inFrontOfAccent--dark.png": 3119,
	"./iconSocialLink__inFrontOfAccent.png": 3120,
	"./iconSocialLink__inactive--dark.png": 3121,
	"./iconSocialLink__inactive.png": 3122,
	"./iconSocialLink__okGreen--dark.png": 3123,
	"./iconSocialLink__okGreen.png": 3124,
	"./iconSocialMail--dark.png": 3125,
	"./iconSocialMail.png": 3126,
	"./iconSocialMail__accent--dark.png": 3127,
	"./iconSocialMail__accent.png": 3128,
	"./iconSocialMail__errorRed--dark.png": 3129,
	"./iconSocialMail__errorRed.png": 3130,
	"./iconSocialMail__inFrontOfAccent--dark.png": 3131,
	"./iconSocialMail__inFrontOfAccent.png": 3132,
	"./iconSocialMail__inactive--dark.png": 3133,
	"./iconSocialMail__inactive.png": 3134,
	"./iconSocialMail__okGreen--dark.png": 3135,
	"./iconSocialMail__okGreen.png": 3136,
	"./iconSocialShare--dark.png": 3137,
	"./iconSocialShare.png": 3138,
	"./iconSocialShare__accent--dark.png": 3139,
	"./iconSocialShare__accent.png": 3140,
	"./iconSocialShare__errorRed--dark.png": 3141,
	"./iconSocialShare__errorRed.png": 3142,
	"./iconSocialShare__inFrontOfAccent--dark.png": 3143,
	"./iconSocialShare__inFrontOfAccent.png": 3144,
	"./iconSocialShare__inactive--dark.png": 3145,
	"./iconSocialShare__inactive.png": 3146,
	"./iconSocialShare__okGreen--dark.png": 3147,
	"./iconSocialShare__okGreen.png": 3148,
	"./iconSocialX--dark.png": 3149,
	"./iconSocialX.png": 3150,
	"./iconSocialX__accent--dark.png": 3151,
	"./iconSocialX__accent.png": 3152,
	"./iconSocialX__errorRed--dark.png": 3153,
	"./iconSocialX__errorRed.png": 3154,
	"./iconSocialX__inFrontOfAccent--dark.png": 3155,
	"./iconSocialX__inFrontOfAccent.png": 3156,
	"./iconSocialX__inactive--dark.png": 3157,
	"./iconSocialX__inactive.png": 3158,
	"./iconSocialX__okGreen--dark.png": 3159,
	"./iconSocialX__okGreen.png": 3160,
	"./iconSquadBet__check.png": 3161,
	"./iconSquadBet__edit.png": 3162,
	"./iconSquadBet__pickArrow.png": 3163,
	"./iconSquadBet__plus.png": 3164,
	"./iconSquadBet__sub.png": 416,
	"./iconSquadBet__tieBreaker.png": 3165,
	"./iconTicket.png": 3166,
	"./iconTrash.png": 3167,
	"./iconTrend--down.png": 3168,
	"./iconTrend--same.png": 3169,
	"./iconTrend--up.png": 3170,
	"./iconTrendDown--dark.png": 3171,
	"./iconTrendDown.png": 3172,
	"./iconTrendDown__accent--dark.png": 3173,
	"./iconTrendDown__accent.png": 3174,
	"./iconTrendDown__errorRed--dark.png": 3175,
	"./iconTrendDown__errorRed.png": 3176,
	"./iconTrendDown__inFrontOfAccent--dark.png": 3177,
	"./iconTrendDown__inFrontOfAccent.png": 3178,
	"./iconTrendDown__inactive--dark.png": 3179,
	"./iconTrendDown__inactive.png": 3180,
	"./iconTrendDown__okGreen--dark.png": 3181,
	"./iconTrendDown__okGreen.png": 3182,
	"./iconTrendUp--dark.png": 3183,
	"./iconTrendUp.png": 3184,
	"./iconTrendUp__accent--dark.png": 3185,
	"./iconTrendUp__accent.png": 3186,
	"./iconTrendUp__errorRed--dark.png": 3187,
	"./iconTrendUp__errorRed.png": 3188,
	"./iconTrendUp__inFrontOfAccent--dark.png": 3189,
	"./iconTrendUp__inFrontOfAccent.png": 3190,
	"./iconTrendUp__inactive--dark.png": 3191,
	"./iconTrendUp__inactive.png": 3192,
	"./iconTrendUp__okGreen--dark.png": 3193,
	"./iconTrendUp__okGreen.png": 3194,
	"./iconUp--dark.png": 3195,
	"./iconUp.png": 3196,
	"./iconUp__accent--dark.png": 3197,
	"./iconUp__accent.png": 3198,
	"./iconUp__errorRed--dark.png": 3199,
	"./iconUp__errorRed.png": 3200,
	"./iconUp__inFrontOfAccent--dark.png": 3201,
	"./iconUp__inFrontOfAccent.png": 3202,
	"./iconUp__inactive--dark.png": 3203,
	"./iconUp__inactive.png": 3204,
	"./iconUp__okGreen--dark.png": 3205,
	"./iconUp__okGreen.png": 3206,
	"./icon__arrow-left--rb-gray.png": 3207,
	"./icon__arrow-left--rb-gray@2x.png": 3208,
	"./icon__arrow-left--rb-gray@3x.png": 3209,
	"./icon__arrow-left--rb-light-gray.png": 3210,
	"./icon__arrow-left--rb-light-gray@2x.png": 3211,
	"./icon__arrow-left--rb-light-gray@3x.png": 3212,
	"./icon__arrow-left.png": 3213,
	"./icon__arrow-left@2x.png": 3214,
	"./icon__arrow-left@3x.png": 3215,
	"./icon__arrow-right--rb-gray.png": 3216,
	"./icon__arrow-right--rb-gray@2x.png": 3217,
	"./icon__arrow-right--rb-gray@3x.png": 3218,
	"./icon__arrow-right--rb-light-gray.png": 3219,
	"./icon__arrow-right--rb-light-gray@2x.png": 3220,
	"./icon__arrow-right--rb-light-gray@3x.png": 3221,
	"./icon__arrow-right.png": 3222,
	"./icon__arrow-right@2x.png": 3223,
	"./icon__arrow-right@3x.png": 3224,
	"./icon__arrow-up-right.png": 3225,
	"./icon__arrow-up-right@2x.png": 3226,
	"./icon__arrow-up-right@3x.png": 3227,
	"./icon__betPick--censored.png": 3228,
	"./icon__betPick--censored@2x.png": 3229,
	"./icon__betPick--censored@3x.png": 3230,
	"./icon__betPick--none.png": 3231,
	"./icon__betPick--none@2x.png": 3232,
	"./icon__betPick--none@3x.png": 3233,
	"./icon__betPick--pick.png": 3234,
	"./icon__betPick--pick@2x.png": 3235,
	"./icon__betPick--pick@3x.png": 3236,
	"./icon__breadcrumbs-arrow-left--rb-raven-gray.png": 3237,
	"./icon__breadcrumbs-arrow-left--rb-raven-gray@2x.png": 3238,
	"./icon__breadcrumbs-arrow-left--rb-raven-gray@3x.png": 3239,
	"./icon__burger-menu.png": 3240,
	"./icon__burger-menu@2x.png": 3241,
	"./icon__burger-menu@3x.png": 3242,
	"./icon__calendar.png": 3243,
	"./icon__calendar@2x.png": 3244,
	"./icon__calendar@3x.png": 3245,
	"./icon__checkmark--rb-dark-gray.png": 3246,
	"./icon__checkmark--rb-dark-gray@2x.png": 3247,
	"./icon__checkmark--rb-dark-gray@3x.png": 3248,
	"./icon__checkmark--white.png": 3249,
	"./icon__checkmark--white@2x.png": 3250,
	"./icon__checkmark--white@3x.png": 3251,
	"./icon__checkmark.png": 3252,
	"./icon__checkmark@2x.png": 3253,
	"./icon__checkmark@3x.png": 3254,
	"./icon__close--rb-dark-gray.png": 3255,
	"./icon__close--rb-dark-gray@2x.png": 3256,
	"./icon__close--rb-dark-gray@3x.png": 3257,
	"./icon__close--rb-gray.png": 3258,
	"./icon__close--rb-gray@2x.png": 3259,
	"./icon__close--rb-gray@3x.png": 3260,
	"./icon__close--rb-white.png": 3261,
	"./icon__close--rb-white@2x.png": 3262,
	"./icon__close--rb-white@3x.png": 3263,
	"./icon__community.png": 3264,
	"./icon__community@2x.png": 3265,
	"./icon__community@3x.png": 3266,
	"./icon__compete.png": 3267,
	"./icon__compete@2x.png": 3268,
	"./icon__compete@3x.png": 3269,
	"./icon__copy-to-clipboard.png": 3270,
	"./icon__copy-to-clipboard@2x.png": 3271,
	"./icon__copy-to-clipboard@3x.png": 3272,
	"./icon__delete--rb-orange.png": 3273,
	"./icon__delete--rb-orange@2x.png": 3274,
	"./icon__delete--rb-orange@3x.png": 3275,
	"./icon__dhi--rb-gray.png": 3276,
	"./icon__dhi--rb-gray@2x.png": 3277,
	"./icon__dhi--rb-gray@3x.png": 3278,
	"./icon__dhi--rb-light-gray.png": 3279,
	"./icon__dhi--rb-light-gray@2x.png": 3280,
	"./icon__dhi--rb-light-gray@3x.png": 3281,
	"./icon__dropdown--arrow.png": 3282,
	"./icon__dropdown--arrow@2x.png": 3283,
	"./icon__dropdown--arrow@3x.png": 3284,
	"./icon__edit--rb-red.png": 3285,
	"./icon__edit--rb-red@2x.png": 3286,
	"./icon__edit--rb-red@3x.png": 3287,
	"./icon__email.png": 3288,
	"./icon__email@2x.png": 3289,
	"./icon__email@3x.png": 3290,
	"./icon__externalLink.png": 3291,
	"./icon__externalLink@2x.png": 3292,
	"./icon__externalLink@3x.png": 3293,
	"./icon__eye--hide.png": 3294,
	"./icon__eye--show.png": 3295,
	"./icon__facebook.png": 3296,
	"./icon__facebook@2x.png": 3297,
	"./icon__facebook@3x.png": 3298,
	"./icon__form--checkmark.png": 3299,
	"./icon__form--checkmark@2x.png": 3300,
	"./icon__form--checkmark@3x.png": 3301,
	"./icon__info--rb-gray.png": 3302,
	"./icon__info--rb-gray@2x.png": 3303,
	"./icon__info--rb-gray@3x.png": 3304,
	"./icon__info--white.png": 3305,
	"./icon__info--white@2x.png": 3306,
	"./icon__info--white@3x.png": 3307,
	"./icon__infoBox--rb-gray.png": 3308,
	"./icon__infoBox--rb-gray@2x.png": 3309,
	"./icon__infoBox--rb-gray@3x.png": 3310,
	"./icon__infoBox.png": 3311,
	"./icon__infoBox@2x.png": 3312,
	"./icon__infoBox@3x.png": 3313,
	"./icon__link.png": 3314,
	"./icon__link@2x.png": 3315,
	"./icon__link@3x.png": 3316,
	"./icon__live.png": 3317,
	"./icon__live@2x.png": 3318,
	"./icon__live@3x.png": 3319,
	"./icon__locked.png": 3320,
	"./icon__locked@2x.png": 3321,
	"./icon__locked@3x.png": 3322,
	"./icon__matchdayNavigation--pagination--arrow.png": 3323,
	"./icon__matchdayNavigation--pagination--arrow@2x.png": 3324,
	"./icon__matchdayNavigation--pagination--arrow@3x.png": 3325,
	"./icon__minus.png": 3326,
	"./icon__minus@2x.png": 3327,
	"./icon__minus@3x.png": 3328,
	"./icon__nativeAppShare.png": 3329,
	"./icon__nativeAppShare@2x.png": 3330,
	"./icon__nativeAppShare@3x.png": 3331,
	"./icon__paginationArrows.png": 3332,
	"./icon__paginationArrows@2x.png": 3333,
	"./icon__paginationArrows@3x.png": 3334,
	"./icon__plus.png": 3335,
	"./icon__plus@2x.png": 3336,
	"./icon__plus@3x.png": 3337,
	"./icon__point--default.png": 3338,
	"./icon__point--default@2x.png": 3339,
	"./icon__point--default@3x.png": 3340,
	"./icon__point--gained.png": 3341,
	"./icon__point--gained@2x.png": 3342,
	"./icon__point--gained@3x.png": 3343,
	"./icon__point--lost.png": 3344,
	"./icon__point--lost@2x.png": 3345,
	"./icon__point--lost@3x.png": 3346,
	"./icon__point--text.png": 3347,
	"./icon__point--text@2x.png": 3348,
	"./icon__point--text@3x.png": 3349,
	"./icon__point--white.png": 3350,
	"./icon__point--white@2x.png": 3351,
	"./icon__point--white@3x.png": 3352,
	"./icon__predict.png": 3353,
	"./icon__predict@2x.png": 3354,
	"./icon__predict@3x.png": 3355,
	"./icon__prize.png": 3356,
	"./icon__prize@2x.png": 3357,
	"./icon__prize@3x.png": 3358,
	"./icon__profile.png": 3359,
	"./icon__profile@2x.png": 3360,
	"./icon__profile@3x.png": 3361,
	"./icon__questionmark--rb-light-gray.png": 3362,
	"./icon__questionmark--rb-light-gray@2x.png": 3363,
	"./icon__questionmark--rb-light-gray@3x.png": 3364,
	"./icon__ranking.png": 3365,
	"./icon__ranking@2x.png": 3366,
	"./icon__ranking@3x.png": 3367,
	"./icon__reddit.png": 3368,
	"./icon__reddit@2x.png": 3369,
	"./icon__reddit@3x.png": 3370,
	"./icon__search--rb-gray.png": 3371,
	"./icon__search--rb-gray@2x.png": 3372,
	"./icon__search--rb-gray@3x.png": 3373,
	"./icon__search--rb-white.png": 3374,
	"./icon__search--rb-white@2x.png": 3375,
	"./icon__search--rb-white@3x.png": 3376,
	"./icon__settings.png": 3377,
	"./icon__settings@2x.png": 3378,
	"./icon__settings@3x.png": 3379,
	"./icon__smallInfoBox.png": 3380,
	"./icon__smallInfoBox@2x.png": 3381,
	"./icon__smallInfoBox@3x.png": 3382,
	"./icon__teaserSampleBetInfo.png": 3383,
	"./icon__teaserSampleBetInfo@2x.png": 3384,
	"./icon__teaserSampleBetInfo@3x.png": 3385,
	"./icon__twitter.png": 3386,
	"./icon__twitter@2x.png": 3387,
	"./icon__twitter@3x.png": 3388,
	"./icon__unlocked.png": 3389,
	"./icon__unlocked@2x.png": 3390,
	"./icon__unlocked@3x.png": 3391,
	"./icon__warning.png": 3392,
	"./icon__warning@2x.png": 3393,
	"./icon__warning@3x.png": 3394,
	"./icon__whatsapp.png": 3395,
	"./icon__whatsapp@2x.png": 3396,
	"./icon__whatsapp@3x.png": 3397,
	"./icon__xco--rb-gray.png": 3398,
	"./icon__xco--rb-gray@2x.png": 3399,
	"./icon__xco--rb-gray@3x.png": 3400,
	"./icon__xco--rb-light-gray.png": 3401,
	"./icon__xco--rb-light-gray@2x.png": 3402,
	"./icon__xco--rb-light-gray@3x.png": 3403,
	"./knockout__pickarrow--inactive@3x.png": 3404,
	"./knockout__pickarrow@3x.png": 3405,
	"./knockout__winnerDeco@3x.png": 3406,
	"./knockoutbet__sample@2x.png": 3407,
	"./landingTeaser__bg--narrow.jpg": 3408,
	"./landingTeaser__bg.jpg": 3409,
	"./landing__eventPrize__prize1.jpg": 3410,
	"./landing__eventPrize__prize2.jpg": 3411,
	"./landing__eventPrize__prize3.jpg": 3412,
	"./landing__seasonPrize__prize0.jpg": 3413,
	"./landing__seasonPrize__prize1.jpg": 3414,
	"./landing__seasonPrize__prize2.jpg": 3415,
	"./landing__seasonPrize__prize3.jpg": 3416,
	"./landing__seasonPrize__prize4.jpg": 3417,
	"./logo--medium.png": 3418,
	"./matchdaySelector__md1--selected.png": 3419,
	"./matchdaySelector__md1.png": 3420,
	"./matchdaySelector__md2--selected.png": 3421,
	"./matchdaySelector__md2.png": 3422,
	"./players/ANCER_ABRAHAM.png": 3423,
	"./players/BLAND_RICHARD.png": 3424,
	"./players/BURMESTER_DEAN.png": 3425,
	"./players/CANTER_LAURIE.png": 3426,
	"./players/CASEY_PAUL.png": 3427,
	"./players/CATLIN_JOHN.png": 3428,
	"./players/CHACARRA_EUGENIO.png": 3429,
	"./players/DECHAMBEAU_BRYSON.png": 3430,
	"./players/DEFAULT.png": 3431,
	"./players/GARCIA_SERGIO.png": 3432,
	"./players/GOOCH_TALOR.png": 3433,
	"./players/GRACE_BRANDEN.png": 3434,
	"./players/HATTON_TYRELL.png": 3435,
	"./players/HERBERT_LUCAS.png": 3436,
	"./players/HORSFIELD_SAM.png": 3437,
	"./players/HOWELL_III_CHARLES.png": 3438,
	"./players/JOHNSON_DUSTIN.png": 3439,
	"./players/JONES_MATT.png": 3440,
	"./players/KAYMER_MARTIN.png": 3441,
	"./players/KIM_ANTHONY.png": 3442,
	"./players/KOEPKA_BROOKS.png": 3443,
	"./players/KOKRAK_JASON.png": 3444,
	"./players/KOZUMA_JINICHIRO.png": 3445,
	"./players/LAHIRI_ANIRBAN.png": 3446,
	"./players/LEE_DANNY.png": 3447,
	"./players/LEISHMAN_MARC.png": 3448,
	"./players/MCDOWELL_GRAEME.png": 3449,
	"./players/MERONK_ADRIAN.png": 3450,
	"./players/MICKELSON_PHIL.png": 3451,
	"./players/MUÑOZ_SEBASTIAN.png": 3452,
	"./players/NA_KEVIN.png": 3453,
	"./players/NIEMANN_JOAQUIN.png": 3454,
	"./players/OGLETREE_ANDY.png": 3455,
	"./players/OOSTHUIZEN_LOUIS.png": 3456,
	"./players/ORTIZ_CARLOS.png": 3457,
	"./players/PEREIRA_MITO.png": 3458,
	"./players/PEREZ_PAT.png": 3459,
	"./players/PIETERS_THOMAS.png": 3460,
	"./players/POULTER_IAN.png": 3461,
	"./players/PUIG_DAVID.png": 3462,
	"./players/RAHM_JON.png": 3463,
	"./players/REED_PATRICK.png": 3464,
	"./players/SAMOOJA_KALLE.png": 3465,
	"./players/SCHWARTZEL_CHARL.png": 3466,
	"./players/SMITH_CAMERON.png": 3467,
	"./players/STEELE_BRENDAN.png": 3468,
	"./players/STENSON_HENRIK.png": 3469,
	"./players/SURRATT_CALEB.png": 3470,
	"./players/SWAFFORD_HUDSON.png": 3471,
	"./players/TRINGALE_CAMERON.png": 3472,
	"./players/UIHLEIN_PETER.png": 3473,
	"./players/VARNER_III_HAROLD.png": 3474,
	"./players/VINCENT_KIERAN.png": 3475,
	"./players/VINCENT_SCOTT.png": 3476,
	"./players/WATSON_BUBBA.png": 3477,
	"./players/WESTWOOD_LEE.png": 3478,
	"./players/WOLFF_MATTHEW.png": 3479,
	"./prizeTeaserDeco.png": 3480,
	"./prize__matchday@2x.jpg": 3481,
	"./prize__saint-brakes.jpg": 3482,
	"./prize__saint-drivetrain.jpg": 3483,
	"./prize__saint-pedals.jpg": 3484,
	"./prize__service.jpg": 3485,
	"./prize__shirt.jpg": 3486,
	"./prize__xt-brakeset.jpg": 3487,
	"./prize__xt-drivechain.jpg": 3488,
	"./prize__xt-wheelset.jpg": 3489,
	"./prize__xtr-pedals.jpg": 3490,
	"./prizes__sidebar--bg.jpg": 3491,
	"./prizes__sidebar--image.png": 3492,
	"./sampleBet__deco.png": 3493,
	"./sampleBet__kranz.png": 3494,
	"./samplePick.png": 3495,
	"./sandbox/knuckles--thumb.png": 3496,
	"./sandbox/knuckles.png": 3497,
	"./sandbox/mario--thumb.png": 3498,
	"./sandbox/mario.png": 3499,
	"./sandbox/megaman--thumb.png": 3500,
	"./sandbox/megaman.png": 3501,
	"./sandbox/peach--thumb.png": 3502,
	"./sandbox/peach.png": 3503,
	"./sandbox/sailormoon--thumb.png": 3504,
	"./sandbox/sailormoon.png": 3505,
	"./sandbox/samus--thumb.png": 3506,
	"./sandbox/samus.png": 3507,
	"./sandbox/sonic--thumb.png": 3508,
	"./sandbox/sonic.png": 3509,
	"./scoreBet__detailScore__markCorrect--dark.png": 3510,
	"./scoreBet__detailScore__markCorrect.png": 3511,
	"./scoreBet__detailScore__markWrong--dark.png": 3512,
	"./scoreBet__detailScore__markWrong.png": 3513,
	"./scoreBet__inProgress.png": 3514,
	"./scoreBet__picker__close.png": 3515,
	"./scoreBet__scoreDown--inactive.png": 3516,
	"./scoreBet__scoreDown.png": 3517,
	"./scoreBet__scoreUp--inactive.png": 3518,
	"./scoreBet__scoreUp.png": 3519,
	"./scoreBet__scoredSoon.png": 3520,
	"./sectionBg--communities.jpg": 3521,
	"./sectionBg--events.jpg": 3522,
	"./sectionBg--ranking.jpg": 3523,
	"./selectionBet__decoPickWinner.png": 3524,
	"./selectionBet__flagBg.jpg": 3525,
	"./social_svgs/facebook.svg": 3526,
	"./social_svgs/instagram.svg": 3527,
	"./social_svgs/tiktok.svg": 3528,
	"./social_svgs/x.svg": 3529,
	"./social_svgs/youtube.svg": 3530,
	"./sponsorBox__bg.jpg": 3531,
	"./sponsorImage.png": 3532,
	"./squadBet__iconChange.png": 3533,
	"./squadBet__iconClearSwap.png": 3534,
	"./squadBet__iconPick.png": 3535,
	"./squadBet__iconSwap.png": 3536,
	"./squadBet__iconSwapSample.png": 3537,
	"./squadBet__playerPlaceholder.png": 3538,
	"./squadBet__teamPlaceholder.png": 3539,
	"./squiggle__bg.png": 3540,
	"./srfLogo.png": 3541,
	"./stat__background.jpg": 3542,
	"./statusPage__503.png": 3543,
	"./statusPage__503@2x.png": 3544,
	"./statusPage__503@3x.png": 3545,
	"./teams/ATALANTA.png": 3546,
	"./teams/BENEVENTO.png": 3547,
	"./teams/BOLOGNA.png": 3548,
	"./teams/BRESCIA.png": 3549,
	"./teams/CAGLIARI.png": 3550,
	"./teams/CROTONE.png": 3551,
	"./teams/FIORENTINA.png": 3552,
	"./teams/GENOA.png": 3553,
	"./teams/INTERNAZIONALE.png": 3554,
	"./teams/JUVENTUS.png": 3555,
	"./teams/LAZIO.png": 3556,
	"./teams/LECCE.png": 3557,
	"./teams/MILAN.png": 3558,
	"./teams/NAPOLI.png": 3559,
	"./teams/PARMA.png": 3560,
	"./teams/ROMA.png": 3561,
	"./teams/SAMPDORIA.png": 3562,
	"./teams/SASSUOLO.png": 3563,
	"./teams/SPAL.png": 3564,
	"./teams/SPEZIA.png": 3565,
	"./teams/TORINO.png": 3566,
	"./teams/UDINESE.png": 3567,
	"./teams/VERONA.png": 3568,
	"./teaser__experten.jpg": 3569,
	"./textSelectionSample__dropdown@2x.png": 3570,
	"./titleSponsor--dark.png": 3571,
	"./titleSponsor.png": 3572,
	"./title__bg.png": 3573,
	"./toyotaLogo@2x.png": 3574,
	"./triangle--down--rb-dark-blue.png": 3575,
	"./triangle--down.png": 3576,
	"./triangle--up.png": 3577,
	"./tutorialSlide__screenshot1.png": 3578,
	"./tutorialSlide__screenshot2.png": 3579,
	"./tutorialSlide__screenshot3.png": 3580,
	"./tutorialSlide__screenshot4.png": 3581,
	"./tutorialSlide__screenshot5.png": 3582,
	"./tutorialSlide__screenshot6.png": 3583,
	"./tutorialSlide__screenshot7.png": 3584,
	"./ui__arrowDown--dark.png": 3585,
	"./ui__arrowDown.png": 3586,
	"./ui__arrowDownInactive--dark.png": 3587,
	"./ui__arrowDownInactive.png": 3588,
	"./ui__arrowLeft--dark.png": 3589,
	"./ui__arrowLeft.png": 3590,
	"./ui__arrowLeftInactive--dark.png": 3591,
	"./ui__arrowLeftInactive.png": 3592,
	"./ui__arrowRight--dark.png": 3593,
	"./ui__arrowRight.png": 3594,
	"./ui__arrowRightInactive--dark.png": 3595,
	"./ui__arrowRightInactive.png": 3596,
	"./ui__arrowUp--dark.png": 3597,
	"./ui__arrowUp.png": 3598,
	"./ui__arrowUpInactive--dark.png": 3599,
	"./ui__arrowUpInactive.png": 3600,
	"./ui__backlinkArrow.svg": 3601,
	"./ui__burgerButton.svg": 3602,
	"./ui__checkArrow--dark.png": 3603,
	"./ui__checkArrow.png": 3604,
	"./ui__infoBox--dark.png": 3605,
	"./ui__infoBox.png": 3606,
	"./ui__infoBoxSmall--dark.png": 3607,
	"./ui__infoBoxSmall.png": 3608,
	"./ui__infoOk--dark.png": 3609,
	"./ui__infoOk.png": 3610,
	"./ui__lockLocked--dark.png": 3611,
	"./ui__lockLocked.png": 3612,
	"./ui__lockUnlocked--dark.png": 3613,
	"./ui__lockUnlocked.png": 3614,
	"./ui__textArrowDown--dark.png": 3615,
	"./ui__textArrowDown.png": 3616,
	"./ui__textArrowDownLight--dark.png": 3617,
	"./ui__textArrowDownLight.png": 3618,
	"./ui__textArrowLeft--dark.png": 3619,
	"./ui__textArrowLeft.png": 3620,
	"./ui__textArrowLeftLight--dark.png": 3621,
	"./ui__textArrowLeftLight.png": 3622,
	"./ui__textArrowRight--dark.png": 3623,
	"./ui__textArrowRight.png": 3624,
	"./ui__textArrowRightLight--dark.png": 3625,
	"./ui__textArrowRightLight.png": 3626,
	"./ui__textArrowUp--dark.png": 3627,
	"./ui__textArrowUp.png": 3628,
	"./ui__textArrowUpLight--dark.png": 3629,
	"./ui__textArrowUpLight.png": 3630,
	"./ui__textCross--dark.png": 3631,
	"./ui__textCross.png": 3632,
	"./ui__textCrossLight--dark.png": 3633,
	"./ui__textCrossLight.png": 3634,
	"./ui__themeToggleDark--dark.png": 3635,
	"./ui__themeToggleDark.png": 3636,
	"./ui__themeToggleLight--dark.png": 3637,
	"./ui__themeToggleLight.png": 3638,
	"./ui__warning--dark.png": 3639,
	"./ui__warning.png": 3640,
	"./winner--left.png": 3641,
	"./winner--right.png": 3642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4049;